import React, { useEffect, useRef, useState } from "react";
import "./dashboard.css";
import Footer from "../../components/footer/Footer";
import Nav from "../../components/nav/Nav";
import CustomButton from "../../components/CustomButton";
import { ReactComponent as HeadephoneIcon } from "../../assets/Headphones Round.svg";
import { ReactComponent as SettingIcon } from "../../assets/Settings.svg";
import { ReactComponent as Map } from "../../assets/map-white.svg";
import { ReactComponent as EyeIcon } from "../../assets/fi-rr-eye.svg";
import { ReactComponent as MessageRedIcon } from "../../assets/messageRedIcon.svg";
import { ReactComponent as NewMessageWhiteIcon } from "../../assets/newMessageWhiteIcon.svg";
import { Modal, Table, Tooltip } from "@mantine/core";
import { Link, useNavigate, useLocation } from "react-router-dom";
import axios from "axios";
import base_url from "../../api/bootapi";
import { useDispatch, useSelector } from "react-redux";
import { logout } from "../../components/Reducers/userSlice";
import { IconContract } from "@tabler/icons-react";
import { IconChevronLeft, IconChevronRight } from "@tabler/icons-react";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import { ReactComponent as DocumentIcon } from "../../assets/Document.svg";
import { ReactComponent as DownloadIcon } from "../../assets/download.svg";
import Swal from "sweetalert2";
import { get } from "react-hook-form";
import { toast } from "react-toastify";
import ViewFileModal from "../../components/Modals/ViewFileModal";
import moment from "moment";
import { Button } from "reactstrap";
import { ReactComponent as Close } from "../../assets/modalCloseIcon.svg";

import AdditionalClaim from "./AdditionalClaim";
import { checkIsLufthansaByClaimType } from "../../components/utils/airlineUtils";
const DashboardPage = () => {
  const navigate = useNavigate();
  const [data, setData] = useState([]);
  const [groupClaimData, setGroupClaimData] = useState([]);
  const { user } = useSelector((state) => state.user);
  const dispatch = useDispatch();
  const [countArray, setCountArray] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [backdropopen, setbackdropopen] = useState(false);
  const [totalMessageCount, setTotalMessageCount] = useState(0);
  const [imageModalOpen, setImageModalOpen] = useState(false);
  const [imageModalTitle, setImageModalTitle] = useState("");
  const [imageModalFileUrl, setImageModalFileUrl] = useState("");
  const [userId, setUserId] = useState(null);  

    const [documentNoteOpened, setDocumentNoteOpened] = useState(false);
  const [documentNote, setDocumentNote] = useState("");
  const [claimId, setClaimId] = useState(null);
  const [additionalFiles, setAdditonalFiles] = useState(null);
  const [normalFile, setNormalFile] = useState(null);
  const [documentType, setDocumentType] = useState(null);

  const poaRefs = useRef({});
  const powerRefs = useRef({});
  const additiionalFileRefs = useRef({});

  const handleUpdateDocumentNote = () => {
    
    if (normalFile) {
      handleUploadDetails(normalFile, claimId, documentType,true);
    return
    }

    if (additionalFiles && additionalFiles?.length > 0) {
      console.log("ClaimId==========>",claimId);
      handleUploadAddionalFiles(additionalFiles, claimId, null, true);
      return
    }

  }

  const handleCloseDocumentNote = () => {
    setDocumentNote("");
    setDocumentNoteOpened(false);

    poaRefs.current[`airline_${claimId}`].value = "";

    setAdditonalFiles(null);
    setDocumentType(null)
    setNormalFile(null)
    setClaimId(null);
    
  }


  const [updatedImageViewModal, setUpdatedImageViewModal] = useState(false);
  const [isWesignModalOpen, setIsWesignModalOpen] = useState(false);
  const [wesignUrl, setWesignUrl] = useState(null);
    const [recipientEmail, setRecipientEmail] = useState(null);
  const [signEnvolpeId, setSignEnvolpeId] = useState(null);
  const [poaClaimId,setPoaClaimId]=useState(null)
  
    const fetchSignedDocument = async (envolpeId,envelopeRecipientEmail=recipientEmail) => {
      const sign_url = `${base_url.api1}/tourapp/wesign_signed_doc_new?id=${envolpeId}&email=${envelopeRecipientEmail}`;
      const response = await axios.get(sign_url);
  
      if (response?.data && response?.data?.status_code === 200) {
        await updateSignerStatus(envelopeRecipientEmail, poaClaimId)
      }
      if (response.data?.Document) {
        const document_url = response.data.Document;
        const pdfResponse = await fetch(document_url);
        if (!pdfResponse.ok) throw new Error("Failed to fetch the document.");
        const genPdfBlob = await pdfResponse.blob();
        return genPdfBlob;
      } else {
        throw new Error("Signed document not found.");
      }
    };
  
    const updateSignerStatus = async (email, claim_id) => {
      const response = await axios.post(
        `${base_url.api1}/tourapp/compensation/signers`,
        {
          recipient: email,
          claim_id: claim_id,
        }
      );
      return response.data; // Return response if needed
  };

    function getClaimType(type) {
  switch (type) {
    case "overbooking":
      return "Denied boarding";
    
    case "denied_boarding":
      return "Denied boarding";

    case "lost_baggage":
      return "Lost luggage";

    case "damage_baggage":
      return "Damaged luggage";

    case "travel_expenses":
      return "Travel expenses";

    case "delayed_baggage":
      return "Delayed luggage";
    
    case "delayed":
      return "Delayed";
    
    case "cancelled":
      return "Cancelled";
    
    case "lost/damaged":
      return "Lost/Damaged";
    
     case "lost_wages":
      return "Lost Wages";
    
    case "other":
      return "Others";
    
     case "others":
      return "Others";
    
     case "dot_claims": return "Dot Claims";
      case "small_claims_eu": return "Small Claims Court - EU";
      case "small_claims_usa": return "Small Claims Court - USA";
      case "small_claims_uk": return "Small Claims Court - UK";
      case "small_claims_il": return "Small Claims Court - IL";
    
   
    

    default:
      return type;
  }
}
  
  const handleClose = async () => {
     setOpenSignerModal(false)
    setIsWesignModalOpen(false);

    try {
      setbackdropopen(true);

      const [genPdfBlob] = await Promise.all([
        fetchSignedDocument(signEnvolpeId),
       
      ]);

     
      if (genPdfBlob) {
        const poaFile = new File([genPdfBlob], "power_of_attorney_dd.pdf", {
          type: genPdfBlob.type,
        });


 await handleUploadDetails(poaFile,poaClaimId,"power_of_attorney")
        
      }

      // setSignatureCaptured(true);
      // setDocumentFetched(true);
      // console.log("Signer status response:", signerStatus);
    } catch (error) {
      console.error("Error during parallel execution:", error);
    } finally {
      setbackdropopen(false);
    }
  };
  
  
  
  const closeImageModal = () => {
    setImageModalOpen(false);
  };
const [openSignerModal,setOpenSignerModal]=useState(false)
  const [lufthansaPoaModalOpen, setLufthansaPoaModalOpen] = useState(false);
  const [selectedLufthansaClaim, setSelectedLufthansaClaim] = useState(null);
  const [signedPoaFile, setSignedPoaFile] = useState(null);
  const [poaUploadError, setPoaUploadError] = useState("");

  const handlePoaSignClick = (claim) => {
    if (!claim) return;

    let originalFlights = claim.flight_details || [];
    if (typeof originalFlights === "string") {
      try {
        originalFlights = JSON.parse(originalFlights);
      } catch (e) {
        console.error("Error parsing original flights", e);
      }
    }

    let actualFlights = claim.actual_flight_details || [];
    if (typeof actualFlights === "string") {
      try {
        actualFlights = JSON.parse(actualFlights);
      } catch (e) {
        console.error("Error parsing actual flights", e);
      }
    }

    const isLufthansa = checkIsLufthansaByClaimType({
      typeOfClaim: claim.type_of_claim,
      originalFlights,
      actualFlights,
    });

    if (isLufthansa) {
      setSelectedLufthansaClaim(claim);
      setSignedPoaFile(null);
      setPoaUploadError("");
      setLufthansaPoaModalOpen(true);
    } else {
      getSignerDetails(claim.id);
    }
  };

  const handleDownloadPoa = async (filePath) => {
    try {
      if (!filePath) {
        Swal.fire({
          icon: "info",
          title: "Document Not Available",
          text: "The Power of Attorney document is currently being prepared. Please try again shortly.",
          confirmButtonColor: "#314064",
        });
        return;
      }
      const fileUrl = filePath.startsWith("http")
        ? filePath
        : `${base_url.api1}${filePath.startsWith("/") ? "" : "/"}${filePath}`;
      const fileName = filePath.split("/").pop() || "power_of_attorney.pdf";

      try {
        const response = await fetch(fileUrl);
        if (response.ok) {
          const blob = await response.blob();
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement("a");
          link.href = url;
          link.download = fileName;
          link.style.display = "none";
          document.body.appendChild(link);
          link.click();
          setTimeout(() => {
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
          }, 100);
          return;
        }
      } catch (e) {
        console.warn("Fetch blob download failed, falling back to window.open", e);
      }

      window.open(fileUrl, "_blank");
    } catch (err) {
      console.error("Error downloading document:", err);
    }
  };

  const handleSubmitLufthansaPoa = async () => {
    if (!signedPoaFile) {
      setPoaUploadError("Please upload the signed Power of Attorney.");
      return;
    }
    if (!selectedLufthansaClaim?.id) return;

    setPoaUploadError("");
    setbackdropopen(true);

    try {
      const formData = new FormData();
      formData.append("power_of_attorney", signedPoaFile);
      const postData = {
        id: selectedLufthansaClaim.id,
        from_customer: true,
      };
      formData.append("data", JSON.stringify(postData));

      await axios.put(
        `${base_url.api1}/tourapp/compensation_request?id=${selectedLufthansaClaim.id}`,
        formData
      );

      await updateTimeline(selectedLufthansaClaim.id);
      setbackdropopen(false);
      setLufthansaPoaModalOpen(false);
      setSignedPoaFile(null);
      setSelectedLufthansaClaim(null);

      Swal.fire({
        icon: "success",
        title: "Success",
        text: "Signed Power of Attorney uploaded successfully.",
        confirmButtonColor: "#314064",
      });

      setUpdatedPOA((prev) => !prev);
    } catch (error) {
      setbackdropopen(false);
      console.error("Error submitting Lufthansa POA:", error);
      setPoaUploadError("Failed to upload Power of Attorney. Please try again.");
    }
  };

  const openSignersDetails = () => {
    setOpenSignerModal(true)
  }

   const handleLoad = () => {
    setbackdropopen(false);
  };

  const [signerDetails, setSignerDetails] = useState([]);

    const getSignerDetails = (claim_id) => {
     setPoaClaimId(claim_id)
      setbackdropopen(true);
      axios
        // https://api.linsoatours.com/tourapp/compensation/signers?claim_id=435
        .get(
          `${base_url.api1}/tourapp/compensation/signers?claim_id=${claim_id}`
        )
        .then((response) => {
          console.log("Signer Details:", response.data);
          setSignerDetails(response.data.signers || []);
  setOpenSignerModal(true)
          // handleCheckSignerStatus(response.data.signers || [])
  
          setbackdropopen(false);
        })
        .catch((error) => {
          console.error("Error fetching signer details:", error);
          setbackdropopen(false);
        });
    };

    const handleSignerClick = (signer) => {
    console.log("Clicked Signer:", signer);
   setShowContinueBtn(false)
      setWesignUrl(signer.sign_url);
    setRecipientEmail(signer.email);
    setSignEnvolpeId(signer.envelope_id);
    setIsWesignModalOpen(true);
      // setbackdropopen(true);
      
         window.history.pushState({ modal: true }, "");

  };


  
    useEffect(() => {
      const onBack = () => {
        if (isWesignModalOpen) {
          setIsWesignModalOpen(false); // Close modal
        }
      };
  
      window.addEventListener("popstate", onBack);
      return () => window.removeEventListener("popstate", onBack);
    }, [isWesignModalOpen]);
  
  
    const [showContinueBtn,setShowContinueBtn]=useState(false)
   useEffect(() => {
      const onMessage = (event) => {
        if (event.data?.type === "IFRAME_URL_CHANGED") {
          console.log("Iframe URL changed to:", event.data.url);
          // Do whatever you need here
          if (event.data.url.includes("postsigning")) {
         setShowContinueBtn(true)
        }
        }
      };
  
      window.addEventListener("message", onMessage);
      return () => window.removeEventListener("message", onMessage);
    }, []);

  const [updatedPOA,setUpdatedPOA]=useState(false);
  const location = useLocation();
  const [compensationData, setCompensationData] = useState(location.state?.compensationData || null);
  const userIdFromState = location.state?.user_id || null;
  const contact = location.state?.contact || null;
  const dob = location.state?.date_of_birth || null;

    const [powerOfAttorneyFile, setPowerOfAttorneyFile] = useState(null);
  
  const getSignerName = (signer) => {
    let name = "";

    if (signer) {
      if (typeof signer !== "string") return "";
      name = signer.charAt(0).toUpperCase() + signer.slice(1).toLowerCase();
      if (name.length > 22) {
        name = name.slice(0, 22) + "...";
      }

      return name;
    } else {
      return "";
    }
  };

    const handleCheckStatus=async(signer) => {
     
        try {
        setbackdropopen(true);
  
        const [genPdfBlob] = await Promise.all([
          fetchSignedDocument(signer.envelope_id,signer.email),
         
        ]);
  
        if (genPdfBlob) {
          const poaFile = new File([genPdfBlob], "power_of_attorney_dd.pdf", {
            type: genPdfBlob.type,
          });
  
           await handleUploadDetails(poaFile,poaClaimId,"power_of_attorney")

        }
  
        // setSignatureCaptured(true);
        // setDocumentFetched(true);
        // console.log("Signer status response:", signerStatus);
      } catch (error) {
        console.error("Error during parallel execution:", error);
      } finally {
        setbackdropopen(false);
      }
    }
    const handleCopyLink = (signer) => {
      const link = signer.sign_url;
      navigator.clipboard
        .writeText(link)
        .then(() => {
          Swal.fire({
            icon: "success",
            title: "Link Copied",
            text: `The signing link has been copied to your clipboard.`,
          });
        })
        .catch((error) => {
          console.error("Failed to copy link:", error);
          Swal.fire({
            icon: "error",
            title: "Copy Failed",
            text: `Failed to copy the signing link.`,
          });
        });
    };
 
  const powerOfAttorneyRef = useRef(null);
    const poaRef = useRef(null);
  
  const addtionalDocumentRef = useRef(null);
  const addtionalDocumentRef1 = useRef(null);
    const [claimFiles, setClaimFiles] = useState({});
  

  console.log("33--------->", compensationData);
  console.log(data);


    useEffect(() => {
    if (!user && !dob && !contact) {
      navigate("/claimstatus");
    }
  }, [user,contact,dob]);

      useEffect(() => {
    if ( !dob && !contact) {
      navigate("/claimstatus");
    }
  }, [contact,dob]);

  // useEffect(() => {
  //   if (!user && !userIdFromState ) {
  //     navigate("/claimstatus");
  //   }
  // }, [userIdFromState]);


   const openImageViewModal = (title, fileUrl) => {
    setImageModalTitle(title);
    setImageModalFileUrl(fileUrl);
    setImageModalOpen(true);
  };
    const isImageFile = (url) => {
    // Example function to check if the URL ends with a common image file extension
    return /\.(jpeg|jpg|png|gif)$/i.test(url);
  };
  const handleViewFile = (elem) => {
      console.log(elem)
      if (!elem) {
        return;
      }
      //console.log("Element", attachmenturl + elem);
      const fileUrl = base_url.api1 + elem;
      if (!isImageFile(fileUrl)) {
        window.open(fileUrl, "_blank");
      } else {
        openImageViewModal("View File", fileUrl);
      }
    };

  useEffect(() => {
    if (data) {
      const readedAdminFalseCounts = data.map((claim) => {
        const notes = claim.note || [];
        return notes.filter((note) => note.readed_customer === false).length; // change this readed_customer
      });
      console.log(readedAdminFalseCounts);
      setCountArray(readedAdminFalseCounts);
      setTotalMessageCount(
        readedAdminFalseCounts.reduce((sum, count) => sum + count, 0)
      );
      console.log("Total unread notes:", totalMessageCount);
    }
  }, [data]);



  
  // useEffect(() => {
  //   const getCompensationList = async () => {
  //     setbackdropopen(true);
  //     try {
  //       const response = await axios.get(
  //         `${base_url.api1}/tourapp/user_compensation_list?user_id=${userIdFromState}&page=${currentPage}`
  //       );

  //       setData(
         
  //           response.data.CompensationRequest
  //       );
  //       setTotalPages(response.data.total_pages || 1);
  //       setbackdropopen(false);
  //       // console.log("fmdskmfdsklmf", response.data.CompensationRequest);
  //     } catch (error) {
  //       console.log("comp list error", error);
  //       setbackdropopen(false);
  //       if (error.response?.status === 403) {
  //         dispatch(logout());
  //         navigate("/login");
  //       }
  //     }
  //   };

  
  //   getCompensationList();
  // }, [currentPage, compensationData,updatedPOA]);

  // const handleClick = () => {
  //   navigate("/details", { state: {  } });
  // };
 


  useEffect(() => {

  const getCompensationByContactAndDob = async () => {
      
  
   
    setbackdropopen(true);

    axios
      .get(
        `${base_url.api1}/tourapp/compensation_request?unique_code=${contact}&date_of_birth=${dob}`
      )
      .then((response) => {
        console.log("31------>", response?.data);
        setbackdropopen(false);
       

       const fetchedClaims = response?.data?.Compensation || response?.data || [];

      const groupClaimsData = fetchedClaims.filter(item => item.group === true);
      const normalClaimsData = fetchedClaims.filter(item => item.group === false);

      setData(normalClaimsData);
      setGroupClaimData(groupClaimsData);

      
        
      })
      .catch((error) => {
        console.log("Error", error);
        setbackdropopen(false);
        Swal.fire({
          icon: "error",
          title: "No Record Found",
         
          confirmButtonText: "Ok",
        });
      });
  
    }
    
    if (contact && dob) {
      getCompensationByContactAndDob();
    }

  },[currentPage,updatedPOA]);

  //  useEffect(() => {
  //   const getCompensationList = async () => {
  //     setbackdropopen(true);
  //     try {
  //       const response = await axios.get(
  //         `${base_url.api1}/tourapp/user_compensation_list?user_id=${user.id}&page=${currentPage}`
  //       );

  //       setData(
  //         response.data.CompensationRequest
  //       );
  //       setTotalPages(response.data.total_pages || 1);
  //       setbackdropopen(false);
  //       // console.log("fmdskmfdsklmf", response.data.CompensationRequest);
  //     } catch (error) {
  //       console.log("comp list error", error);
  //       setbackdropopen(false);
  //       if (error.response?.status === 403) {
  //         dispatch(logout());
  //         navigate("/login");
  //       }
  //     }
  //   };

  //    if (user?.id) {
  //     getCompensationList();
  //   }
  
  // }, [currentPage,updatedPOA]);
 
 
  const handleEditClick = (id) => {
    navigate(`/edit-claim/${id}`);
  };

   const truncateText = (file) => {
    if (!file) {
      return false;
    }

    const tempFile = file?.split("/").pop();

    const filename =
      tempFile.length > 12 ? tempFile.slice(0, 12) + "..." : tempFile;

    return filename;
  };

   const getShortUpdatedFilename = (file, lengthOfText = 15) => {
    if (!file) {
      return;
    }

    const filename =
      file.name.length > lengthOfText
        ? file.name.slice(0, lengthOfText) + "..."
        : file.name;

    return filename;
  };

    const handleDownloadClick = async (file_name) => {
      try {
        const fileUrl = `${base_url.api1}${file_name}`;
        const fileName = file_name?.split("/").pop() || "document.pdf";
  
        // Fetch the file as a blob
        const response = await fetch(fileUrl);
        const blob = await response.blob();
  
        // Create a download link
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.download = fileName;
        link.style.display = "none";
  
        document.body.appendChild(link);
        link.click();
  
        // Clean up
        setTimeout(() => {
          document.body.removeChild(link);
          window.URL.revokeObjectURL(url);
        }, 100);
      } catch (error) {
        console.error("Download failed:", error);
        // Optionally show error to user
      }
  };
  
   const handleUpdatedFileChange = (e, type,claim_id,user_id) => {
    const file = e.target.files;
    if (file) {
      setClaimFiles((prevFiles) => ({
        ...prevFiles,
        [type]: file[0],
      }));

      console.log(claim_id)

      


    setUserId(user_id)
handleUploadDetails(file[0],claim_id,type);
     
    }
  };

  const handleUploadAddionalFiles = (files, claim_id,user_id, skipFileCheck = false) => {
    
    console.log(claim_id)

    
      if (files.length === 0) {
        return;
        
    }



    if (!skipFileCheck) {
      
      setAdditonalFiles(files)
      setClaimId(claim_id)
      setDocumentNoteOpened(true);
      return
    }
    

    
     setbackdropopen(true);

  
      const formData = new FormData();
  
      let data = {
        claim_id: claim_id,
        from_customer: true,
    };
    
     if (skipFileCheck) {
      data.document_note= documentNote
      
    }
  
    formData.append("data", JSON.stringify(data));
    files = Array.from(files);
      files.forEach((file) => {
        formData.append("document", file);
      });
  
      axios.post(`${base_url.api1}/tourapp/claim_doc`, formData).then(
        (response) => {
          setbackdropopen(false);
  
          // toast.error(JSON.stringify("Files uploaded successfully"));

             Swal.fire({
            icon: "success",
            title: "Success",
            text: `Files uploaded successfully`,
             });
          
                   handleCloseDocumentNote()

          setUpdatedPOA(prev=>!prev);

          console.log("Success");
        },
        (error) => {
          setbackdropopen(false);
          handleCloseDocumentNote()

          toast.error(JSON.stringify(error.message));
        }
      );
  };



 
    const updateTimeline = async(claim_id) => {
      
       let timelineObject = {
        status: "Updated",
            notes: "Claim request documents has been updated.",
         timestamp: moment().format("h:mm A MMMM D, YYYY"),
        claim_id: claim_id,
      
      };
        const sendTimelineUrl = `${base_url.api1}/tourapp/claim_log`; // Replace with your actual URL
    
        axios
          .post(sendTimelineUrl, timelineObject, {})
          .then((response) => {
             console.log(response)
          })
          .catch((error) => {
            console.log(error)
          setbackdropopen(false);
            
          });
      };

  
  
  const handleUploadDetails = async(file,claim_id,type,skipFileCheck=false) => {
    const formData = new FormData();
  

    if (type === "airline_poa" && !skipFileCheck) {
      setClaimId(claim_id);
      setNormalFile(file);
      setDocumentType(type);
      setDocumentNoteOpened(true);

      return

    }

      let data = {
      id: claim_id,
      from_customer: true,
    };


    if (skipFileCheck) {
      data.document_note = documentNote
    }
   
    if (file) {
      if (type === "power_of_attorney") {
        
        formData.append("power_of_attorney", file);
      } else if (type === "airline_poa") {
        formData.append("airline_poa", file);
        
      }
    }
   



 

 

          setbackdropopen(true);


    
    formData.append("data", JSON.stringify(data));
  
   
    
    axios
      .put(
        `${base_url.api1}/tourapp/compensation_request?id=${claim_id}`,
        formData
        // {
        //   headers: {
        //     Authorization: jwtToken,
        //   },
        // }
      )
      .then(
        async(response) => {
          // toast.success("Success");
           await updateTimeline(claim_id);
        
         
          setClaimFiles({});
        
        
          window.scrollTo(0, 0);
          Swal.fire({
            icon: "success",
            title: "Success",
            text: `Claim Updated successfully.`,
          });
          
          handleCloseDocumentNote()
          setbackdropopen(false);

         
        setUpdatedPOA(prev=>!prev);
          console.log("Success");
        },
        (error) => {
          window.scrollTo(0, 0);

          setbackdropopen(false);
          handleCloseDocumentNote()

          Swal.fire({
            icon: "error",
            title: "Error",
            text: `Failed to update claim.`,
          });
          // toast.error(JSON.stringify(error.message));
        }
      );
  };

  const [additonalMainClaim, setAdditionalMailClaim] = useState(null);
const [openAdditionalModal,setOpenAdditonalModal]=useState(false)
  
  const openAdditonalModal = (claim) => {
    setAdditionalMailClaim(claim);
setOpenAdditonalModal(true)
  }
  
  const mobileRows = data?.map((element, index) => {
    
const otherClaims = element?.additional_claim || []

     const allAddionalDocs = element.sub_claims
  .filter(member => member.additional_doc)
  .map(member => ({
    document: member.additional_doc
  }));

const combinedDocs = [...allAddionalDocs, ...element.other_doc];

// ✅ Get total length
    const totalLength = combinedDocs.length;
    

    return (
    <div className="mobile-row" key={element.id}>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "8px",
          }}
        >
          <span
            className="claim-id-text"
            style={{
              color: "#222222",
              fontSize: "18px",
              lineHeight: "20px",
              fontWeight: 600,
            }}
          >
            Claim ID: <span className="claim-id">{ element.unique_claim_id|| element.contact_no}</span>
          </span>
          <span className="message-text">
            {" "}
            <span
              style={{
                width: "10px ",
                height: "10px",
                borderRadius: "50%",
                backgroundColor:
                  element.newMessages > 0 ? "#D04244" : "#E6F6FF",
              }}
            ></span>
            {countArray[index] === 0 ? (
              <div className="dashboard-new-message-container">
                <NewMessageWhiteIcon />
                <span className="sub-header">No message</span>
              </div>
            ) : (
              <div className="dashboard-new-message-container">
                <MessageRedIcon />
                <span className="sub-header">
                  {countArray[index]}  message
                </span>
              </div>
            )}
          </span>
        </div>

        {/* <span
          style={{
            width: "48px",
            height: "48px",
            borderRadius: "50%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            background: "#E8EEF7",
            cursor: "pointer",
          }}
          onClick={() => navigate(`/view-claim/${element.id}`)}
        >
          <EyeIcon />
        </span> */}
      </div>

      <hr style={{ color: "#CBDAF0" }} />

      <div
        style={{
          display: "flex",
          flexDirection: "column",
          gap: "16px",
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <span className="sub-header">Submitted date</span>

          <span
            style={{ fontSize: "14px", lineHeight: "20px", color: "#222222" }}
          >
            {new Date(element.created_date).toLocaleDateString("en-US")}
          </span>
          </div>
          
            <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <span className="sub-header">Name</span>

          <span
            style={{ fontSize: "14px", lineHeight: "20px", color: "#222222" }}
          >
            {element?.first_name} {element?.last_name}
          </span>
        </div>

        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <span className="sub-header">Claim type</span>

          <span
            style={{
              fontSize: "14px",
              lineHeight: "20px",
              color: "#222222",
              textTransform: "capitalize",
            }}
          >
            {element?.type_of_claim
              ? element?.type_of_claim === "overbooking" ||
                element?.type_of_claim === "denied_boarding"
                ? "Denied Boarding"
                : getClaimType(element?.type_of_claim)
              : "-"}
          </span>
        </div>

        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <span className="sub-header">Status</span>

          <span className="mobile-claim-label">
            {
              <span
                style={{
                  textTransform: "capitalize",
                  fontSize: "14px",
                  lineHeight: "20px",
                  borderRadius: "16px",
                  padding: "4px 16px",
                  backgroundColor:
                    element.status === "In review"
                      ? "rgba(255, 193, 7, 0.1)" // yellow (light)
                      : element.status === "Waiting for airline"
                      ? "rgba(229, 116, 45, 0.1)" // orange (unchanged)
                      : element.status === "Documents needed"
                      ? "rgba(208, 66, 68, 0.1)" // red (unchanged)
                      : element.status === "paid"
                      ? "rgba(33, 150, 243, 0.1)" // blue (light)
                      : element.status === "approved"
                      ? "rgba(76, 175, 80, 0.1)" // green (optional, since not specified)
                      : element.status === "appealed"
                      ? "rgba(255, 152, 0, 0.1)" // deep orange
                      : element.status === "rejected"
                      ? "rgba(244, 67, 54, 0.1)" // red (stronger)
                      : element.status === "incomplete"
                      ? "rgba(158, 158, 158, 0.1)" // grey
                      : element.status === "pending"
                      ? "rgba(255, 152, 0, 0.1)" // orange
                      : "rgba(0, 0, 0, 0.1)", // default
                  color:
                    element.status === "In review"
                      ? "#FFC107" // yellow
                      : element.status === "Waiting for airline"
                      ? "#E5742D" // orange (unchanged)
                      : element.status === "Documents needed"
                      ? "#D04244" // red (unchanged)
                      : element.status === "paid"
                      ? "#2196F3" // blue
                      : element.status === "approved"
                      ? "#4CAF50" // green
                      : element.status === "appealed"
                      ? "#FF9800" // deep orange
                      : element.status === "rejected"
                      ? "#F44336" // red
                      : element.status === "incomplete"
                      ? "#717171ff" // grey
                      : element.status === "pending"
                      ? "#FF9800" // orange
                      : "rgba(0, 0, 0, 1)", // default
                }}
              >
                {element.status}
              </span>
            }
          </span>
        </div>
        {/* {element.status === "incomplete" && (
          <button
            className="dashboard-edit-button"
            onClick={() => handleEditClick(element.id)}
          >
            <IconContract size={18} color="#314064" /> Draft
          </button>
        )} */}
      </div>
 {element.sub_claims.length > 0 && (
        <div style={{marginTop:"16px",display:"flex",flexDirection:"column",gap:"8px"}}>
          <span className="sub-header">Power of Attorney</span>
                              <div className="document-wrapper" style={{width:"fit-content !important"}}>
                                                     <span
                                                       onClick={() =>
                                                         handleViewFile(element.power_of_attorney)
                                                       }
                                                       className="icon"
                                                       style={{ backgroundColor: "#799DD2" }}
                                                     >
                                                       <DocumentIcon />
                                                     </span>
                                                     <p
                                                       className="sub-header"
                                                       style={{ color: "#222222" }}
                                                     >
                                                       {getShortUpdatedFilename(
                                                        powerRefs.current[`power_${element.id}`]?.files?.[0],
                                                         12
                                                       ) ||
                                                         truncateText(element?.power_of_attorney) ||
                                                         "No Power of Attorney"}{" "}
                                                       {/* <span style={{ color: "#858585" }}>(6.7 MB)</span> */}
                                                     </p>
                             
                                                     {/* {!claimData?.power_of_attorney && (
                                                       <>
                                                         {" "} */}
                                                     <div className="signer-status">
                                                       <input
                                                         style={{ display: "none" }}
                                                              ref={(el) => (powerRefs.current[`power_${element.id}`] = el)}
                                                         onChange={(e) =>
                                                           handleUpdatedFileChange(e, "power_of_attorney",element?.id,element?.user_id)
                                                         }
                
                                                         type="file"
                                                         className="form-control mt-2"
                                                         name="power_of_attorney"
                                                       />
                                                       <span
                                                                             onClick={() => powerRefs.current[`power_${element.id}`]?.click()}

                                                         className="icon"
                                                         style={{ border: "1px solid rgb(49, 64, 100)" }}
                                                       >
                                                         <svg
                                                           width="18px"
                                                           height="18px"
                                                           viewBox="0 0 24 24"
                                                           fill="none"
                                                           xmlns="http://www.w3.org/2000/svg"
                                                         >
                                                           <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                                                           <g
                                                             id="SVGRepo_tracerCarrier"
                                                             stroke-linecap="round"
                                                             stroke-linejoin="round"
                                                           ></g>
                                                           <g id="SVGRepo_iconCarrier">
                                                             {" "}
                                                             <path
                                                               d="M20.1497 7.93997L8.27971 19.81C7.21971 20.88 4.04971 21.3699 3.27971 20.6599C2.50971 19.9499 3.06969 16.78 4.12969 15.71L15.9997 3.84C16.5478 3.31801 17.2783 3.03097 18.0351 3.04019C18.7919 3.04942 19.5151 3.35418 20.0503 3.88938C20.5855 4.42457 20.8903 5.14781 20.8995 5.90463C20.9088 6.66146 20.6217 7.39189 20.0997 7.93997H20.1497Z"
                                                               stroke="#314064"
                                                               stroke-width="1.5"
                                                               stroke-linecap="round"
                                                               stroke-linejoin="round"
                                                             ></path>{" "}
                                                             <path
                                                               d="M21 21H12"
                                                               stroke="#314064"
                                                               stroke-width="1.5"
                                                               stroke-linecap="round"
                                                               stroke-linejoin="round"
                                                             ></path>{" "}
                                                           </g>
                                                         </svg>
                                                       </span>
                
                  <Tooltip label='Sign'>
                                                        
                  
                                                    <span
                                                      className="sign-btn"
                                                      onClick={() => handlePoaSignClick(element)}
                                                    >
                                                      <svg
                                                        fill="#314064"
                                                        width="20px"
                                                        height="20px"
                                                        viewBox="0 0 56 56"
                                                        xmlns="http://www.w3.org/2000/svg"
                                                      >
                                                        <g
                                                          id="SVGRepo_bgCarrier"
                                                          stroke-width="0"
                                                        ></g>
                                                        <g
                                                          id="SVGRepo_tracerCarrier"
                                                          stroke-linecap="round"
                                                          stroke-linejoin="round"
                                                        ></g>
                                                        <g id="SVGRepo_iconCarrier">
                                                          <path d="M 1.1883 43.4869 L 13.6935 43.4869 C 13.4483 44.4300 13.3162 45.3542 13.3162 46.2030 C 13.3162 49.2397 15.0138 51.4088 18.5786 51.4088 C 22.9168 51.4088 26.4250 48.3532 28.6884 43.4869 L 54.8118 43.4869 C 55.4719 43.4869 56 42.9777 56 42.3175 C 56 41.6574 55.4719 41.1670 54.8118 41.1670 L 29.6315 41.1670 C 30.6877 38.0737 31.3290 34.4523 31.4611 30.5290 C 32.6494 30.2650 33.8941 30.1329 35.1769 30.1329 C 35.8371 30.1329 36.2141 30.4159 36.2141 30.9063 C 36.2141 32.5472 35.3276 33.8298 35.3276 35.4708 C 35.3276 36.9043 36.3841 37.7719 37.7608 37.7719 C 41.5896 37.7719 46.2108 31.2269 47.7385 31.2269 C 49.1342 31.2269 47.3990 37.1117 52.1522 37.1117 C 52.9256 37.1117 53.9253 36.9043 54.6986 36.4139 C 55.1513 36.0932 55.4719 35.6405 55.4719 35.0558 C 55.4719 34.3391 55.0192 33.7544 54.2648 33.7544 C 53.6046 33.7544 53.0577 34.3013 52.4164 34.3013 C 50.3792 34.3013 52.3218 28.0393 48.5687 28.0393 C 45.2868 28.0393 40.1561 34.4145 38.8548 34.4145 C 38.6852 34.4145 38.5531 34.3202 38.5531 34.0939 C 38.5531 33.4149 39.4017 31.8871 39.4017 30.3593 C 39.4017 28.4732 37.8361 27.2660 35.3844 27.2660 C 34.0451 27.2660 32.7248 27.3980 31.4611 27.6432 C 31.0461 17.7032 26.3307 9.8756 19.1256 9.8756 C 14.2782 9.8756 10.5436 14.0063 10.5436 19.2687 C 10.5436 25.4176 14.5423 30.6799 19.5217 34.1693 C 17.3149 36.3384 15.5985 38.8093 14.5423 41.1670 L 1.1883 41.1670 C .5281 41.1670 0 41.6574 0 42.3175 C 0 42.9777 .5281 43.4869 1.1883 43.4869 Z M 13.4106 19.2687 C 13.4106 15.5907 15.9003 12.7426 19.1256 12.7426 C 24.7841 12.7426 28.4432 19.7780 28.6130 28.4166 C 26.0101 29.3219 23.6335 30.6988 21.5776 32.3397 C 17.6544 29.6237 13.4106 25.1347 13.4106 19.2687 Z M .6413 37.1495 C 1.1317 37.6399 1.8673 37.6210 2.3765 37.1495 L 4.7342 34.7918 L 7.0919 37.1495 C 7.5823 37.6399 8.3368 37.6399 8.8272 37.1495 C 9.3176 36.6591 9.3176 35.9046 8.8272 35.4142 L 6.4695 33.0754 L 8.8272 30.7177 C 9.3176 30.2273 9.3176 29.4917 8.8272 29.0012 C 8.3368 28.4920 7.5823 28.5109 7.0919 29.0012 L 4.7342 31.3401 L 2.3765 29.0012 C 1.8673 28.4920 1.1317 28.4920 .6413 29.0012 C .1509 29.4917 .1509 30.2461 .6413 30.7177 L 2.9990 33.0754 L .6413 35.4142 C .1509 35.9235 .1509 36.6591 .6413 37.1495 Z M 23.6335 36.5459 C 23.8787 36.6591 24.1051 36.7156 24.3314 36.7156 C 25.1047 36.7156 25.6517 36.1121 25.6517 35.4708 C 25.6517 34.9992 25.4254 34.5466 24.8784 34.2825 C 24.6143 34.1505 24.3503 34.0184 24.0674 33.8675 C 25.4254 32.9056 26.9343 32.0568 28.5564 31.4155 C 28.3300 35.0558 27.6322 38.4132 26.5571 41.1670 L 17.5790 41.1670 C 18.5597 39.3185 20.0309 37.3758 21.8982 35.6594 C 22.4641 35.9800 23.0488 36.2630 23.6335 36.5459 Z M 16.2586 45.6560 C 16.2586 44.9959 16.3718 44.2603 16.6170 43.4869 L 25.4820 43.4869 C 23.7844 46.6180 21.5022 48.5418 18.8993 48.5418 C 17.0886 48.5418 16.2586 47.3536 16.2586 45.6560 Z"></path>
                                                        </g>
                                                      </svg>
                                                    </span>
                                                        </Tooltip>
                             
                                                       {/* {element?.power_of_attorney && (
                                                         <span
                                                           onClick={() =>
                                                             handleDownloadClick(
                                                               element?.power_of_attorney
                                                             )
                                                           }
                                                           className="icon"
                                                           style={{ border: "1px solid #314064" }}
                                                         >
                                                           <DownloadIcon />
                                                         </span>
                                                       )} */}
                                                     </div>
                             
                                                     {/* </>
                                                     )} */}
                                                   </div>
                            </div>
        )}
        

         {/* {element.sub_claims.length > 0 && ( */}
        <div style={{marginTop:"16px",display:"flex",flexDirection:"column",gap:"8px"}}>
          <span className="sub-header">Airline POA</span>
                               <div className="document-wrapper" style={{ width: "fit-content !important" }}>
                <span
                  onClick={() =>
                    handleViewFile(element?.airline_poa)
                  }
                  className="icon"
                  style={{ backgroundColor: "#799DD2" }}
                >
                  <DocumentIcon />
                </span>
                <p
                  className="sub-header"
                  style={{ color: "#222222" }}
                >
                  {getShortUpdatedFilename(
                    poaRefs.current[`airline_${element.id}`]?.files?.[0],
                    20
                  ) ||
                    truncateText(element?.airline_poa) ||
                    "No Airline POA"}{" "}
                  {/* <span style={{ color: "#858585" }}>(6.7 MB)</span> */}
                </p>
                             
                {/* {!claimData?.power_of_attorney && (
                                                       <>
                                                         {" "} */}
                <div className="signer-status">
                  <input
                    style={{ display: "none" }}
                                                   ref={(el) => (poaRefs.current[`airline_${element.id}`] = el)}

                    onChange={(e) =>
                      handleUpdatedFileChange(e, "airline_poa", element?.id, element?.user_id)
                    }
                    type="file"
                    className="form-control mt-2"
                    name="airline_poa"
                  />
 {!element?.airline_poa && (
                  <span
                     onClick={() => poaRefs.current[`airline_${element.id}`]?.click()}
                    className="icon"
                    style={{ border: "1px solid rgb(49, 64, 100)" }}
                  >
                    <svg
                      width="18px"
                      height="18px"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                      <g
                        id="SVGRepo_tracerCarrier"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      ></g>
                      <g id="SVGRepo_iconCarrier">
                        {" "}
                        <path
                          d="M20.1497 7.93997L8.27971 19.81C7.21971 20.88 4.04971 21.3699 3.27971 20.6599C2.50971 19.9499 3.06969 16.78 4.12969 15.71L15.9997 3.84C16.5478 3.31801 17.2783 3.03097 18.0351 3.04019C18.7919 3.04942 19.5151 3.35418 20.0503 3.88938C20.5855 4.42457 20.8903 5.14781 20.8995 5.90463C20.9088 6.66146 20.6217 7.39189 20.0997 7.93997H20.1497Z"
                          stroke="#314064"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        ></path>{" "}
                        <path
                          d="M21 21H12"
                          stroke="#314064"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        ></path>{" "}
                      </g>
                    </svg>
                  </span>
                  )}
                             
                  {/* {element?.airline_poa && (
                    <span
                      onClick={() =>
                        handleDownloadClick(
                          element?.airline_poa
                        )
                      }
                      className="icon"
                      style={{ border: "1px solid #314064" }}
                    >
                      <DownloadIcon />
                    </span>
                  )} */}
                </div>
                             
                {/* </>
                                                     )} */}
              </div>
                            </div>
      {/* )} */}
      
      <div style={{marginTop:"16px",display:"flex",flexDirection:"column",gap:"8px"}}>
          <span className="sub-header">Upload Claim Docs</span>
                            <div className="document-wrapper" style={{ width: "fit-content !important" }}>
              
                <p
                  className="sub-header"
                  style={{ color: "#222222" }}
                >
                 {totalLength > 0 ?totalLength :"No"} Documents
                </p>
                             
              
                <div className="signer-status">
                  <input
                    style={{ display: "none" }}
                   ref={(el) => (additiionalFileRefs.current[`additional_${element.id}`] = el)}
                    onChange={(e) =>
                      handleUploadAddionalFiles(e.target.files,  element?.id, element?.user_id)
                    }
                type="file"
                multiple
                    className="form-control mt-2"
                    // name="power_of_attorney"
                  />
                  <span
                   onClick={() => additiionalFileRefs.current[`additional_${element.id}`]?.click()}
                    className="icon"
                    style={{ border: "1px solid rgb(49, 64, 100)" }}
                  >
                    <svg
                      width="18px"
                      height="18px"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                      <g
                        id="SVGRepo_tracerCarrier"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      ></g>
                      <g id="SVGRepo_iconCarrier">
                        {" "}
                        <path
                          d="M20.1497 7.93997L8.27971 19.81C7.21971 20.88 4.04971 21.3699 3.27971 20.6599C2.50971 19.9499 3.06969 16.78 4.12969 15.71L15.9997 3.84C16.5478 3.31801 17.2783 3.03097 18.0351 3.04019C18.7919 3.04942 19.5151 3.35418 20.0503 3.88938C20.5855 4.42457 20.8903 5.14781 20.8995 5.90463C20.9088 6.66146 20.6217 7.39189 20.0997 7.93997H20.1497Z"
                          stroke="#314064"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        ></path>{" "}
                        <path
                          d="M21 21H12"
                          stroke="#314064"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        ></path>{" "}
                      </g>
                    </svg>
                  </span>
                             
                  {/* {element?.power_of_attorney && (
                    <span
                      onClick={() =>
                        handleDownloadClick(
                          element?.power_of_attorney
                        )
                      }
                      className="icon"
                      style={{ border: "1px solid #314064" }}
                    >
                      <DownloadIcon />
                    </span>
                  )} */}
                </div>
                             
                {/* </>
                                                     )} */}
              </div>
                            </div>
        <button className="access-btn" style={{ width: "100%", height: "initial", marginTop: "20px", padding: "12px", fontSize: "14px" }} onClick={() => navigate(`/view-claim/${element.id}`)}>Access Your Claim</button>
        
          <button className="access-btn" style={{ width: "100%", height: "initial", marginTop: "20px", padding: "12px", fontSize: "14px" }} onClick={() => openAdditonalModal(element)}>Add Sub Claim</button>


        {
          otherClaims?.length > 0 && <h3 style={{fontSize:"20px",marginTop:"25px"}}>Sub Claims</h3>
  }

        
        {
          otherClaims?.length > 0 && otherClaims?.map((otherClaim, index) => {

            
            const allAddionalDocs = otherClaim.sub_claims
              .filter(member => member.additional_doc)
              .map(member => ({
                document: member.additional_doc
              }));

            const combinedDocs = [...allAddionalDocs, ...otherClaim.other_doc];
            const totalLength = combinedDocs.length;

            return  <div className="mobile-row" style={{padding:"0",border:"none",marginTop:"20px"}} key={otherClaim.id}>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "8px",
          }}
        >
          <span
            className="claim-id-text"
            style={{
              color: "#222222",
              fontSize: "18px",
              lineHeight: "20px",
              fontWeight: 600,
            }}
          >
            Claim ID: <span className="claim-id">{otherClaim.contact_no}-A{index + 1}</span>
          </span>
          <span className="message-text">
            {" "}
            <span
              style={{
                width: "10px ",
                height: "10px",
                borderRadius: "50%",
                backgroundColor:
                  otherClaim.newMessages > 0 ? "#D04244" : "#E6F6FF",
              }}
                    >
                      
            </span>
            {/* {countArray[index] === 0 ? (
              <div className="dashboard-new-message-container">
                <NewMessageWhiteIcon />
                <span className="sub-header">No new message</span>
              </div>
            ) : (
              <div className="dashboard-new-message-container">
                <MessageRedIcon />
                <span className="sub-header">
                  {countArray[index]} new message
                </span>
              </div>
            )} */}
          </span>
        </div>

        {/* <span
          style={{
            width: "48px",
            height: "48px",
            borderRadius: "50%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            background: "#E8EEF7",
            cursor: "pointer",
          }}
          onClick={() => navigate(`/view-claim/${otherClaim.id}`)}
        >
          <EyeIcon />
        </span> */}
      </div>

      <hr style={{ color: "#CBDAF0" }} />

      <div
        style={{
          display: "flex",
          flexDirection: "column",
          gap: "16px",
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <span className="sub-header">Submitted date</span>

          <span
            style={{ fontSize: "14px", lineHeight: "20px", color: "#222222" }}
          >
            {new Date(otherClaim.created_date).toLocaleDateString("en-US")}
          </span>
          </div>
          
            <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <span className="sub-header">Name</span>

          <span
            style={{ fontSize: "14px", lineHeight: "20px", color: "#222222" }}
          >
            {otherClaim?.first_name} {otherClaim?.last_name}
          </span>
        </div>

        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <span className="sub-header">Claim type</span>

          <span
            style={{
              fontSize: "14px",
              lineHeight: "20px",
              color: "#222222",
              textTransform: "capitalize",
            }}
          >
            {otherClaim?.type_of_claim
              ? getClaimType(otherClaim?.type_of_claim)
              : "-"}
          </span>
        </div>

        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <span className="sub-header">Status</span>

          <span className="mobile-claim-label">
            {
              <span
                style={{
                  textTransform: "capitalize",
                  fontSize: "14px",
                  lineHeight: "20px",
                  borderRadius: "16px",
                  padding: "4px 16px",
                  backgroundColor:
                    otherClaim.status === "In review"
                      ? "rgba(255, 193, 7, 0.1)" // yellow (light)
                      : otherClaim.status === "Waiting for airline"
                      ? "rgba(229, 116, 45, 0.1)" // orange (unchanged)
                      : otherClaim.status === "Documents needed"
                      ? "rgba(208, 66, 68, 0.1)" // red (unchanged)
                      : otherClaim.status === "paid"
                      ? "rgba(33, 150, 243, 0.1)" // blue (light)
                      : otherClaim.status === "approved"
                      ? "rgba(76, 175, 80, 0.1)" // green (optional, since not specified)
                      : otherClaim.status === "appealed"
                      ? "rgba(255, 152, 0, 0.1)" // deep orange
                      : otherClaim.status === "rejected"
                      ? "rgba(244, 67, 54, 0.1)" // red (stronger)
                      : otherClaim.status === "incomplete"
                      ? "rgba(158, 158, 158, 0.1)" // grey
                      : otherClaim.status === "pending"
                      ? "rgba(255, 152, 0, 0.1)" // orange
                      : "rgba(0, 0, 0, 0.1)", // default
                  color:
                    otherClaim.status === "In review"
                      ? "#FFC107" // yellow
                      : otherClaim.status === "Waiting for airline"
                      ? "#E5742D" // orange (unchanged)
                      : otherClaim.status === "Documents needed"
                      ? "#D04244" // red (unchanged)
                      : otherClaim.status === "paid"
                      ? "#2196F3" // blue
                      : otherClaim.status === "approved"
                      ? "#4CAF50" // green
                      : otherClaim.status === "appealed"
                      ? "#FF9800" // deep orange
                      : otherClaim.status === "rejected"
                      ? "#F44336" // red
                      : otherClaim.status === "incomplete"
                      ? "#717171ff" // grey
                      : otherClaim.status === "pending"
                      ? "#FF9800" // orange
                      : "rgba(0, 0, 0, 1)", // default
                }}
              >
                {otherClaim.status}
              </span>
            }
          </span>
        </div>
        {/* {otherClaim.status === "incomplete" && (
          <button
            className="dashboard-edit-button"
            onClick={() => handleEditClick(otherClaim.id)}
          >
            <IconContract size={18} color="#314064" /> Draft
          </button>
        )} */}
      </div>
{otherClaim.sub_claims.length > 0 ? (
            <>
              <div className="document-wrapper" style={{ width: "fit-content !important" }}>
                 <Tooltip label='View'>
              
                <span
                  onClick={() =>
                    handleViewFile(otherClaim.power_of_attorney)
                  }
                  className="icon"
                  style={{ backgroundColor: "#799DD2" }}
                >
                  <DocumentIcon />
                  </span>
                  
                  </Tooltip>
                <p
                  className="sub-header"
                  style={{ color: "#222222" }}
                >
                  {getShortUpdatedFilename(
                    powerRefs.current[`power_${otherClaim.id}`]?.files?.[0],
                    12
                  ) ||
                    truncateText(otherClaim?.power_of_attorney) ||
                    "No Power of Attorney"}{" "}
                  {/* <span style={{ color: "#858585" }}>(6.7 MB)</span> */}
                </p>
                             
                {/* {!claimData?.power_of_attorney && (
                                                       <>
                                                         {" "} */}
                <div className="signer-status">
                  <input
                    style={{ display: "none" }}
                        ref={(el) => (powerRefs.current[`power_${otherClaim.id}`] = el)}
                    onChange={(e) =>
                      handleUpdatedFileChange(e, "power_of_attorney", otherClaim?.id, otherClaim?.user_id)
                    }
                    type="file"
                    className="form-control mt-2"
                    name="power_of_attorney"
                  />
                    <span
                       onClick={() => powerRefs.current[`power_${otherClaim.id}`]?.click()}
                      
                    className="icon"
                    style={{ border: "1px solid rgb(49, 64, 100)" }}
                  >
                    <svg
                      width="18px"
                      height="18px"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                      <g
                        id="SVGRepo_tracerCarrier"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      ></g>
                      <g id="SVGRepo_iconCarrier">
                        {" "}
                        <path
                          d="M20.1497 7.93997L8.27971 19.81C7.21971 20.88 4.04971 21.3699 3.27971 20.6599C2.50971 19.9499 3.06969 16.78 4.12969 15.71L15.9997 3.84C16.5478 3.31801 17.2783 3.03097 18.0351 3.04019C18.7919 3.04942 19.5151 3.35418 20.0503 3.88938C20.5855 4.42457 20.8903 5.14781 20.8995 5.90463C20.9088 6.66146 20.6217 7.39189 20.0997 7.93997H20.1497Z"
                          stroke="#314064"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        ></path>{" "}
                        <path
                          d="M21 21H12"
                          stroke="#314064"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        ></path>{" "}
                      </g>
                    </svg>
                  </span>

                   <Tooltip label='Sign'>
                                                        
                  
                                                    <span
                                                      className="sign-btn"
                                                      onClick={() => handlePoaSignClick(otherClaim)}
                                                    >
                                                      <svg
                                                        fill="#314064"
                                                        width="20px"
                                                        height="20px"
                                                        viewBox="0 0 56 56"
                                                        xmlns="http://www.w3.org/2000/svg"
                                                      >
                                                        <g
                                                          id="SVGRepo_bgCarrier"
                                                          stroke-width="0"
                                                        ></g>
                                                        <g
                                                          id="SVGRepo_tracerCarrier"
                                                          stroke-linecap="round"
                                                          stroke-linejoin="round"
                                                        ></g>
                                                        <g id="SVGRepo_iconCarrier">
                                                          <path d="M 1.1883 43.4869 L 13.6935 43.4869 C 13.4483 44.4300 13.3162 45.3542 13.3162 46.2030 C 13.3162 49.2397 15.0138 51.4088 18.5786 51.4088 C 22.9168 51.4088 26.4250 48.3532 28.6884 43.4869 L 54.8118 43.4869 C 55.4719 43.4869 56 42.9777 56 42.3175 C 56 41.6574 55.4719 41.1670 54.8118 41.1670 L 29.6315 41.1670 C 30.6877 38.0737 31.3290 34.4523 31.4611 30.5290 C 32.6494 30.2650 33.8941 30.1329 35.1769 30.1329 C 35.8371 30.1329 36.2141 30.4159 36.2141 30.9063 C 36.2141 32.5472 35.3276 33.8298 35.3276 35.4708 C 35.3276 36.9043 36.3841 37.7719 37.7608 37.7719 C 41.5896 37.7719 46.2108 31.2269 47.7385 31.2269 C 49.1342 31.2269 47.3990 37.1117 52.1522 37.1117 C 52.9256 37.1117 53.9253 36.9043 54.6986 36.4139 C 55.1513 36.0932 55.4719 35.6405 55.4719 35.0558 C 55.4719 34.3391 55.0192 33.7544 54.2648 33.7544 C 53.6046 33.7544 53.0577 34.3013 52.4164 34.3013 C 50.3792 34.3013 52.3218 28.0393 48.5687 28.0393 C 45.2868 28.0393 40.1561 34.4145 38.8548 34.4145 C 38.6852 34.4145 38.5531 34.3202 38.5531 34.0939 C 38.5531 33.4149 39.4017 31.8871 39.4017 30.3593 C 39.4017 28.4732 37.8361 27.2660 35.3844 27.2660 C 34.0451 27.2660 32.7248 27.3980 31.4611 27.6432 C 31.0461 17.7032 26.3307 9.8756 19.1256 9.8756 C 14.2782 9.8756 10.5436 14.0063 10.5436 19.2687 C 10.5436 25.4176 14.5423 30.6799 19.5217 34.1693 C 17.3149 36.3384 15.5985 38.8093 14.5423 41.1670 L 1.1883 41.1670 C .5281 41.1670 0 41.6574 0 42.3175 C 0 42.9777 .5281 43.4869 1.1883 43.4869 Z M 13.4106 19.2687 C 13.4106 15.5907 15.9003 12.7426 19.1256 12.7426 C 24.7841 12.7426 28.4432 19.7780 28.6130 28.4166 C 26.0101 29.3219 23.6335 30.6988 21.5776 32.3397 C 17.6544 29.6237 13.4106 25.1347 13.4106 19.2687 Z M .6413 37.1495 C 1.1317 37.6399 1.8673 37.6210 2.3765 37.1495 L 4.7342 34.7918 L 7.0919 37.1495 C 7.5823 37.6399 8.3368 37.6399 8.8272 37.1495 C 9.3176 36.6591 9.3176 35.9046 8.8272 35.4142 L 6.4695 33.0754 L 8.8272 30.7177 C 9.3176 30.2273 9.3176 29.4917 8.8272 29.0012 C 8.3368 28.4920 7.5823 28.5109 7.0919 29.0012 L 4.7342 31.3401 L 2.3765 29.0012 C 1.8673 28.4920 1.1317 28.4920 .6413 29.0012 C .1509 29.4917 .1509 30.2461 .6413 30.7177 L 2.9990 33.0754 L .6413 35.4142 C .1509 35.9235 .1509 36.6591 .6413 37.1495 Z M 23.6335 36.5459 C 23.8787 36.6591 24.1051 36.7156 24.3314 36.7156 C 25.1047 36.7156 25.6517 36.1121 25.6517 35.4708 C 25.6517 34.9992 25.4254 34.5466 24.8784 34.2825 C 24.6143 34.1505 24.3503 34.0184 24.0674 33.8675 C 25.4254 32.9056 26.9343 32.0568 28.5564 31.4155 C 28.3300 35.0558 27.6322 38.4132 26.5571 41.1670 L 17.5790 41.1670 C 18.5597 39.3185 20.0309 37.3758 21.8982 35.6594 C 22.4641 35.9800 23.0488 36.2630 23.6335 36.5459 Z M 16.2586 45.6560 C 16.2586 44.9959 16.3718 44.2603 16.6170 43.4869 L 25.4820 43.4869 C 23.7844 46.6180 21.5022 48.5418 18.8993 48.5418 C 17.0886 48.5418 16.2586 47.3536 16.2586 45.6560 Z"></path>
                                                        </g>
                                                      </svg>
                                                    </span>
                                                        </Tooltip>
                             
                  {/* {element?.power_of_attorney && (
                 <Tooltip label='Download'>

                    <span
                      onClick={() =>
                        handleDownloadClick(
                          element?.power_of_attorney
                        )
                      }
                      className="icon"
                      style={{ border: "1px solid #314064" }}
                    >
                      <DownloadIcon />
                      </span>
                 </Tooltip>
                      
                  )} */}
                </div>
                             
                {/* </>
                                                     )} */}
              </div>
            </>
          ) : "-"}
        

         {/* {otherClaim.sub_claims.length > 0 ? ( */}
            <>
              <div className="document-wrapper" style={{ width: "fit-content !important" }}>
                 <Tooltip label='View'>
                <span
                  onClick={() =>
                    handleViewFile(otherClaim?.airline_poa)
                  }
                  className="icon"
                  style={{ backgroundColor: "#799DD2" }}
                >
                  <DocumentIcon />
                  </span>
                  </Tooltip>
                <p
                  className="sub-header"
                  style={{ color: "#222222" }}
                >
                  {getShortUpdatedFilename(
                     poaRefs.current[`airline_${otherClaim.id}`]?.files?.[0],
                    20
                  ) ||
                    truncateText(otherClaim?.airline_poa) ||
                    "No Airline POA"}{" "}
                  {/* <span style={{ color: "#858585" }}>(6.7 MB)</span> */}
                </p>
                             
                {/* {!claimData?.power_of_attorney && (
                                                       <>
                                                         {" "} */}
                <div className="signer-status">
                  <input
                    style={{ display: "none" }}
                                                                                                      ref={(el) => (poaRefs.current[`airline_${otherClaim.id}`] = el)}


                    onChange={(e) =>
                      handleUpdatedFileChange(e, "airline_poa", otherClaim?.id, otherClaim?.user_id)
                    }
                    type="file"
                    className="form-control mt-2"
                    name="airline_poa"
                  />
                  {!otherClaim?.airline_poa && (
                    <Tooltip label='Edit'>

                   
                  <span
                     onClick={() => poaRefs.current[`airline_${otherClaim.id}`]?.click()}
                    className="icon"
                    style={{ border: "1px solid rgb(49, 64, 100)" }}
                  >
                    <svg
                      width="18px"
                      height="18px"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                      <g
                        id="SVGRepo_tracerCarrier"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      ></g>
                      <g id="SVGRepo_iconCarrier">
                        {" "}
                        <path
                          d="M20.1497 7.93997L8.27971 19.81C7.21971 20.88 4.04971 21.3699 3.27971 20.6599C2.50971 19.9499 3.06969 16.78 4.12969 15.71L15.9997 3.84C16.5478 3.31801 17.2783 3.03097 18.0351 3.04019C18.7919 3.04942 19.5151 3.35418 20.0503 3.88938C20.5855 4.42457 20.8903 5.14781 20.8995 5.90463C20.9088 6.66146 20.6217 7.39189 20.0997 7.93997H20.1497Z"
                          stroke="#314064"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        ></path>{" "}
                        <path
                          d="M21 21H12"
                          stroke="#314064"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        ></path>{" "}
                      </g>
                    </svg>
                      </span>
                      
                       </Tooltip>
                  )}
                             
                  {/* {element?.airline_poa && (
                    <Tooltip label='Download'>
                    <span
                      onClick={() =>
                        handleDownloadClick(
                          element?.airline_poa
                        )
                      }
                      className="icon"
                      style={{ border: "1px solid #314064" }}
                    >
                      <DownloadIcon />
                      </span>
                      </Tooltip>
                  )} */}
                </div>
                             
                {/* </>
                                                     )} */}
              </div>
            </>
          {/* ) : "-"} */}
      
      <div style={{marginTop:"16px",display:"flex",flexDirection:"column",gap:"8px"}}>
          <span className="sub-header">Upload Claim Docs</span>
                            <div className="document-wrapper" style={{ width: "fit-content !important" }}>
              
                <p
                  className="sub-header"
                  style={{ color: "#222222" }}
                >
                 {totalLength > 0 ?totalLength :"No"} Documents
                </p>
                             
              
                <div className="signer-status">
                  <input
                    style={{ display: "none" }}
                    ref={addtionalDocumentRef1}
                    onChange={(e) =>
                      handleUploadAddionalFiles(e.target.files,  otherClaim?.id, otherClaim?.user_id)
                    }
                type="file"
                multiple
                    className="form-control mt-2"
                    // name="power_of_attorney"
                  />
                  <span
                    onClick={() => addtionalDocumentRef1.current.click()}
                    className="icon"
                    style={{ border: "1px solid rgb(49, 64, 100)" }}
                  >
                    <svg
                      width="18px"
                      height="18px"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                      <g
                        id="SVGRepo_tracerCarrier"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      ></g>
                      <g id="SVGRepo_iconCarrier">
                        {" "}
                        <path
                          d="M20.1497 7.93997L8.27971 19.81C7.21971 20.88 4.04971 21.3699 3.27971 20.6599C2.50971 19.9499 3.06969 16.78 4.12969 15.71L15.9997 3.84C16.5478 3.31801 17.2783 3.03097 18.0351 3.04019C18.7919 3.04942 19.5151 3.35418 20.0503 3.88938C20.5855 4.42457 20.8903 5.14781 20.8995 5.90463C20.9088 6.66146 20.6217 7.39189 20.0997 7.93997H20.1497Z"
                          stroke="#314064"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        ></path>{" "}
                        <path
                          d="M21 21H12"
                          stroke="#314064"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        ></path>{" "}
                      </g>
                    </svg>
                  </span>
                             
                
                </div>
                             
              
              </div>
                            </div>
        <button className="access-btn" style={{width:"100%",height:"initial",marginTop:"20px",padding:"12px",fontSize:"14px"}}  onClick={() => navigate(`/view-claim/${otherClaim.id}`)}>Access Your Claim</button>
</div>



          })
        }
        

    </div>
  )
  } 
  );

   const mobileGroupRows = groupClaimData?.map((element, index) => {
    
const otherClaims = element?.additional_claim || []

     const allAddionalDocs = element.sub_claims
  .filter(member => member.additional_doc)
  .map(member => ({
    document: member.additional_doc
  }));

const combinedDocs = [...allAddionalDocs, ...element.other_doc];

// ✅ Get total length
    const totalLength = combinedDocs.length;
    

    return (
    <div className="mobile-row" key={element.id}>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "8px",
          }}
        >
          <span
            className="claim-id-text"
            style={{
              color: "#222222",
              fontSize: "18px",
              lineHeight: "20px",
              fontWeight: 600,
            }}
          >
            Claim ID: <span className="claim-id">{ element.unique_claim_id|| element.contact_no}</span>
          </span>
          <span className="message-text">
            {" "}
            <span
              style={{
                width: "10px ",
                height: "10px",
                borderRadius: "50%",
                backgroundColor:
                  element.newMessages > 0 ? "#D04244" : "#E6F6FF",
              }}
            ></span>
            {countArray[index] === 0 ? (
              <div className="dashboard-new-message-container">
                <NewMessageWhiteIcon />
                <span className="sub-header">No message</span>
              </div>
            ) : (
              <div className="dashboard-new-message-container">
                <MessageRedIcon />
                <span className="sub-header">
                  {countArray[index]}  message
                </span>
              </div>
            )}
          </span>
        </div>

        {/* <span
          style={{
            width: "48px",
            height: "48px",
            borderRadius: "50%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            background: "#E8EEF7",
            cursor: "pointer",
          }}
          onClick={() => navigate(`/view-claim/${element.id}`)}
        >
          <EyeIcon />
        </span> */}
      </div>

      <hr style={{ color: "#CBDAF0" }} />

      <div
        style={{
          display: "flex",
          flexDirection: "column",
          gap: "16px",
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <span className="sub-header">Submitted date</span>

          <span
            style={{ fontSize: "14px", lineHeight: "20px", color: "#222222" }}
          >
            {new Date(element.created_date).toLocaleDateString("en-US")}
          </span>
          </div>
          
            <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <span className="sub-header">Group Name</span>

          <span
            style={{ fontSize: "14px", lineHeight: "20px", color: "#222222" }}
          >
            {element?.group_name}
          </span>
        </div>

        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <span className="sub-header">Claim type</span>

          <span
            style={{
              fontSize: "14px",
              lineHeight: "20px",
              color: "#222222",
              textTransform: "capitalize",
            }}
          >
            {element?.type_of_claim
              ? element?.type_of_claim === "overbooking" ||
                element?.type_of_claim === "denied_boarding"
                ? "Denied Boarding"
                : getClaimType(element?.type_of_claim)
              : "-"}
          </span>
        </div>

        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <span className="sub-header">Status</span>

          <span className="mobile-claim-label">
            {
              <span
                style={{
                  textTransform: "capitalize",
                  fontSize: "14px",
                  lineHeight: "20px",
                  borderRadius: "16px",
                  padding: "4px 16px",
                  backgroundColor:
                    element.status === "In review"
                      ? "rgba(255, 193, 7, 0.1)" // yellow (light)
                      : element.status === "Waiting for airline"
                      ? "rgba(229, 116, 45, 0.1)" // orange (unchanged)
                      : element.status === "Documents needed"
                      ? "rgba(208, 66, 68, 0.1)" // red (unchanged)
                      : element.status === "paid"
                      ? "rgba(33, 150, 243, 0.1)" // blue (light)
                      : element.status === "approved"
                      ? "rgba(76, 175, 80, 0.1)" // green (optional, since not specified)
                      : element.status === "appealed"
                      ? "rgba(255, 152, 0, 0.1)" // deep orange
                      : element.status === "rejected"
                      ? "rgba(244, 67, 54, 0.1)" // red (stronger)
                      : element.status === "incomplete"
                      ? "rgba(158, 158, 158, 0.1)" // grey
                      : element.status === "pending"
                      ? "rgba(255, 152, 0, 0.1)" // orange
                      : "rgba(0, 0, 0, 0.1)", // default
                  color:
                    element.status === "In review"
                      ? "#FFC107" // yellow
                      : element.status === "Waiting for airline"
                      ? "#E5742D" // orange (unchanged)
                      : element.status === "Documents needed"
                      ? "#D04244" // red (unchanged)
                      : element.status === "paid"
                      ? "#2196F3" // blue
                      : element.status === "approved"
                      ? "#4CAF50" // green
                      : element.status === "appealed"
                      ? "#FF9800" // deep orange
                      : element.status === "rejected"
                      ? "#F44336" // red
                      : element.status === "incomplete"
                      ? "#717171ff" // grey
                      : element.status === "pending"
                      ? "#FF9800" // orange
                      : "rgba(0, 0, 0, 1)", // default
                }}
              >
                {element.status}
              </span>
            }
          </span>
        </div>
        {/* {element.status === "incomplete" && (
          <button
            className="dashboard-edit-button"
            onClick={() => handleEditClick(element.id)}
          >
            <IconContract size={18} color="#314064" /> Draft
          </button>
        )} */}
      </div>
 {element.sub_claims.length > 0 && (
        <div style={{marginTop:"16px",display:"flex",flexDirection:"column",gap:"8px"}}>
          <span className="sub-header">Power of Attorney</span>
                              <div className="document-wrapper" style={{width:"fit-content !important"}}>
                                                     <span
                                                       onClick={() =>
                                                         handleViewFile(element.power_of_attorney)
                                                       }
                                                       className="icon"
                                                       style={{ backgroundColor: "#799DD2" }}
                                                     >
                                                       <DocumentIcon />
                                                     </span>
                                                     <p
                                                       className="sub-header"
                                                       style={{ color: "#222222" }}
                                                     >
                                                       {getShortUpdatedFilename(
                                                        powerRefs.current[`power_${element.id}`]?.files?.[0],
                                                         12
                                                       ) ||
                                                         truncateText(element?.power_of_attorney) ||
                                                         "No Power of Attorney"}{" "}
                                                       {/* <span style={{ color: "#858585" }}>(6.7 MB)</span> */}
                                                     </p>
                             
                                                     {/* {!claimData?.power_of_attorney && (
                                                       <>
                                                         {" "} */}
                                                     <div className="signer-status">
                                                       <input
                                                         style={{ display: "none" }}
                                                              ref={(el) => (powerRefs.current[`power_${element.id}`] = el)}
                                                         onChange={(e) =>
                                                           handleUpdatedFileChange(e, "power_of_attorney",element?.id,element?.user_id)
                                                         }
                
                                                         type="file"
                                                         className="form-control mt-2"
                                                         name="power_of_attorney"
                                                       />
                                                       <span
                                                                             onClick={() => powerRefs.current[`power_${element.id}`]?.click()}

                                                         className="icon"
                                                         style={{ border: "1px solid rgb(49, 64, 100)" }}
                                                       >
                                                         <svg
                                                           width="18px"
                                                           height="18px"
                                                           viewBox="0 0 24 24"
                                                           fill="none"
                                                           xmlns="http://www.w3.org/2000/svg"
                                                         >
                                                           <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                                                           <g
                                                             id="SVGRepo_tracerCarrier"
                                                             stroke-linecap="round"
                                                             stroke-linejoin="round"
                                                           ></g>
                                                           <g id="SVGRepo_iconCarrier">
                                                             {" "}
                                                             <path
                                                               d="M20.1497 7.93997L8.27971 19.81C7.21971 20.88 4.04971 21.3699 3.27971 20.6599C2.50971 19.9499 3.06969 16.78 4.12969 15.71L15.9997 3.84C16.5478 3.31801 17.2783 3.03097 18.0351 3.04019C18.7919 3.04942 19.5151 3.35418 20.0503 3.88938C20.5855 4.42457 20.8903 5.14781 20.8995 5.90463C20.9088 6.66146 20.6217 7.39189 20.0997 7.93997H20.1497Z"
                                                               stroke="#314064"
                                                               stroke-width="1.5"
                                                               stroke-linecap="round"
                                                               stroke-linejoin="round"
                                                             ></path>{" "}
                                                             <path
                                                               d="M21 21H12"
                                                               stroke="#314064"
                                                               stroke-width="1.5"
                                                               stroke-linecap="round"
                                                               stroke-linejoin="round"
                                                             ></path>{" "}
                                                           </g>
                                                         </svg>
                                                       </span>
                
                  <Tooltip label='Sign'>
                                                        
                  
                                                    <span
                                                      className="sign-btn"
                                                      onClick={() => handlePoaSignClick(element)}
                                                    >
                                                      <svg
                                                        fill="#314064"
                                                        width="20px"
                                                        height="20px"
                                                        viewBox="0 0 56 56"
                                                        xmlns="http://www.w3.org/2000/svg"
                                                      >
                                                        <g
                                                          id="SVGRepo_bgCarrier"
                                                          stroke-width="0"
                                                        ></g>
                                                        <g
                                                          id="SVGRepo_tracerCarrier"
                                                          stroke-linecap="round"
                                                          stroke-linejoin="round"
                                                        ></g>
                                                        <g id="SVGRepo_iconCarrier">
                                                          <path d="M 1.1883 43.4869 L 13.6935 43.4869 C 13.4483 44.4300 13.3162 45.3542 13.3162 46.2030 C 13.3162 49.2397 15.0138 51.4088 18.5786 51.4088 C 22.9168 51.4088 26.4250 48.3532 28.6884 43.4869 L 54.8118 43.4869 C 55.4719 43.4869 56 42.9777 56 42.3175 C 56 41.6574 55.4719 41.1670 54.8118 41.1670 L 29.6315 41.1670 C 30.6877 38.0737 31.3290 34.4523 31.4611 30.5290 C 32.6494 30.2650 33.8941 30.1329 35.1769 30.1329 C 35.8371 30.1329 36.2141 30.4159 36.2141 30.9063 C 36.2141 32.5472 35.3276 33.8298 35.3276 35.4708 C 35.3276 36.9043 36.3841 37.7719 37.7608 37.7719 C 41.5896 37.7719 46.2108 31.2269 47.7385 31.2269 C 49.1342 31.2269 47.3990 37.1117 52.1522 37.1117 C 52.9256 37.1117 53.9253 36.9043 54.6986 36.4139 C 55.1513 36.0932 55.4719 35.6405 55.4719 35.0558 C 55.4719 34.3391 55.0192 33.7544 54.2648 33.7544 C 53.6046 33.7544 53.0577 34.3013 52.4164 34.3013 C 50.3792 34.3013 52.3218 28.0393 48.5687 28.0393 C 45.2868 28.0393 40.1561 34.4145 38.8548 34.4145 C 38.6852 34.4145 38.5531 34.3202 38.5531 34.0939 C 38.5531 33.4149 39.4017 31.8871 39.4017 30.3593 C 39.4017 28.4732 37.8361 27.2660 35.3844 27.2660 C 34.0451 27.2660 32.7248 27.3980 31.4611 27.6432 C 31.0461 17.7032 26.3307 9.8756 19.1256 9.8756 C 14.2782 9.8756 10.5436 14.0063 10.5436 19.2687 C 10.5436 25.4176 14.5423 30.6799 19.5217 34.1693 C 17.3149 36.3384 15.5985 38.8093 14.5423 41.1670 L 1.1883 41.1670 C .5281 41.1670 0 41.6574 0 42.3175 C 0 42.9777 .5281 43.4869 1.1883 43.4869 Z M 13.4106 19.2687 C 13.4106 15.5907 15.9003 12.7426 19.1256 12.7426 C 24.7841 12.7426 28.4432 19.7780 28.6130 28.4166 C 26.0101 29.3219 23.6335 30.6988 21.5776 32.3397 C 17.6544 29.6237 13.4106 25.1347 13.4106 19.2687 Z M .6413 37.1495 C 1.1317 37.6399 1.8673 37.6210 2.3765 37.1495 L 4.7342 34.7918 L 7.0919 37.1495 C 7.5823 37.6399 8.3368 37.6399 8.8272 37.1495 C 9.3176 36.6591 9.3176 35.9046 8.8272 35.4142 L 6.4695 33.0754 L 8.8272 30.7177 C 9.3176 30.2273 9.3176 29.4917 8.8272 29.0012 C 8.3368 28.4920 7.5823 28.5109 7.0919 29.0012 L 4.7342 31.3401 L 2.3765 29.0012 C 1.8673 28.4920 1.1317 28.4920 .6413 29.0012 C .1509 29.4917 .1509 30.2461 .6413 30.7177 L 2.9990 33.0754 L .6413 35.4142 C .1509 35.9235 .1509 36.6591 .6413 37.1495 Z M 23.6335 36.5459 C 23.8787 36.6591 24.1051 36.7156 24.3314 36.7156 C 25.1047 36.7156 25.6517 36.1121 25.6517 35.4708 C 25.6517 34.9992 25.4254 34.5466 24.8784 34.2825 C 24.6143 34.1505 24.3503 34.0184 24.0674 33.8675 C 25.4254 32.9056 26.9343 32.0568 28.5564 31.4155 C 28.3300 35.0558 27.6322 38.4132 26.5571 41.1670 L 17.5790 41.1670 C 18.5597 39.3185 20.0309 37.3758 21.8982 35.6594 C 22.4641 35.9800 23.0488 36.2630 23.6335 36.5459 Z M 16.2586 45.6560 C 16.2586 44.9959 16.3718 44.2603 16.6170 43.4869 L 25.4820 43.4869 C 23.7844 46.6180 21.5022 48.5418 18.8993 48.5418 C 17.0886 48.5418 16.2586 47.3536 16.2586 45.6560 Z"></path>
                                                        </g>
                                                      </svg>
                                                    </span>
                                                        </Tooltip>
                             
                                                       {/* {element?.power_of_attorney && (
                                                         <span
                                                           onClick={() =>
                                                             handleDownloadClick(
                                                               element?.power_of_attorney
                                                             )
                                                           }
                                                           className="icon"
                                                           style={{ border: "1px solid #314064" }}
                                                         >
                                                           <DownloadIcon />
                                                         </span>
                                                       )} */}
                                                     </div>
                             
                                                     {/* </>
                                                     )} */}
                                                   </div>
                            </div>
        )}
        

         {/* {element.sub_claims.length > 0 && ( */}
        <div style={{marginTop:"16px",display:"flex",flexDirection:"column",gap:"8px"}}>
          <span className="sub-header">Airline POA</span>
                               <div className="document-wrapper" style={{ width: "fit-content !important" }}>
                <span
                  onClick={() =>
                    handleViewFile(element?.airline_poa)
                  }
                  className="icon"
                  style={{ backgroundColor: "#799DD2" }}
                >
                  <DocumentIcon />
                </span>
                <p
                  className="sub-header"
                  style={{ color: "#222222" }}
                >
                  {getShortUpdatedFilename(
                    poaRefs.current[`airline_${element.id}`]?.files?.[0],
                    20
                  ) ||
                    truncateText(element?.airline_poa) ||
                    "No Airline POA"}{" "}
                  {/* <span style={{ color: "#858585" }}>(6.7 MB)</span> */}
                </p>
                             
                {/* {!claimData?.power_of_attorney && (
                                                       <>
                                                         {" "} */}
                <div className="signer-status">
                  <input
                    style={{ display: "none" }}
                                                   ref={(el) => (poaRefs.current[`airline_${element.id}`] = el)}

                    onChange={(e) =>
                      handleUpdatedFileChange(e, "airline_poa", element?.id, element?.user_id)
                    }
                    type="file"
                    className="form-control mt-2"
                    name="airline_poa"
                  />
 {/* {!element?.airline_poa && (
                  <span
                     onClick={() => poaRefs.current[`airline_${element.id}`]?.click()}
                    className="icon"
                    style={{ border: "1px solid rgb(49, 64, 100)" }}
                  >
                    <svg
                      width="18px"
                      height="18px"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                      <g
                        id="SVGRepo_tracerCarrier"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      ></g>
                      <g id="SVGRepo_iconCarrier">
                        {" "}
                        <path
                          d="M20.1497 7.93997L8.27971 19.81C7.21971 20.88 4.04971 21.3699 3.27971 20.6599C2.50971 19.9499 3.06969 16.78 4.12969 15.71L15.9997 3.84C16.5478 3.31801 17.2783 3.03097 18.0351 3.04019C18.7919 3.04942 19.5151 3.35418 20.0503 3.88938C20.5855 4.42457 20.8903 5.14781 20.8995 5.90463C20.9088 6.66146 20.6217 7.39189 20.0997 7.93997H20.1497Z"
                          stroke="#314064"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        ></path>{" "}
                        <path
                          d="M21 21H12"
                          stroke="#314064"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        ></path>{" "}
                      </g>
                    </svg>
                  </span>
                  )} */}
                             
                  {/* {element?.airline_poa && (
                    <span
                      onClick={() =>
                        handleDownloadClick(
                          element?.airline_poa
                        )
                      }
                      className="icon"
                      style={{ border: "1px solid #314064" }}
                    >
                      <DownloadIcon />
                    </span>
                  )} */}
                </div>
                             
                {/* </>
                                                     )} */}
              </div>
                            </div>
      {/* )} */}
      
      <div style={{marginTop:"16px",display:"flex",flexDirection:"column",gap:"8px"}}>
          <span className="sub-header">Upload Claim Docs</span>
                            <div className="document-wrapper" style={{ width: "fit-content !important" }}>
              
                <p
                  className="sub-header"
                  style={{ color: "#222222" }}
                >
                 {totalLength > 0 ?totalLength :"No"} Documents
                </p>
                             
              
                <div className="signer-status">
                  <input
                    style={{ display: "none" }}
                   ref={(el) => (additiionalFileRefs.current[`additional_${element.id}`] = el)}
                    onChange={(e) =>
                      handleUploadAddionalFiles(e.target.files,  element?.id, element?.user_id)
                    }
                type="file"
                multiple
                    className="form-control mt-2"
                    // name="power_of_attorney"
                  />
                  <span
                   onClick={() => additiionalFileRefs.current[`additional_${element.id}`]?.click()}
                    className="icon"
                    style={{ border: "1px solid rgb(49, 64, 100)" }}
                  >
                    <svg
                      width="18px"
                      height="18px"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                      <g
                        id="SVGRepo_tracerCarrier"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      ></g>
                      <g id="SVGRepo_iconCarrier">
                        {" "}
                        <path
                          d="M20.1497 7.93997L8.27971 19.81C7.21971 20.88 4.04971 21.3699 3.27971 20.6599C2.50971 19.9499 3.06969 16.78 4.12969 15.71L15.9997 3.84C16.5478 3.31801 17.2783 3.03097 18.0351 3.04019C18.7919 3.04942 19.5151 3.35418 20.0503 3.88938C20.5855 4.42457 20.8903 5.14781 20.8995 5.90463C20.9088 6.66146 20.6217 7.39189 20.0997 7.93997H20.1497Z"
                          stroke="#314064"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        ></path>{" "}
                        <path
                          d="M21 21H12"
                          stroke="#314064"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        ></path>{" "}
                      </g>
                    </svg>
                  </span>
                             
                  {/* {element?.power_of_attorney && (
                    <span
                      onClick={() =>
                        handleDownloadClick(
                          element?.power_of_attorney
                        )
                      }
                      className="icon"
                      style={{ border: "1px solid #314064" }}
                    >
                      <DownloadIcon />
                    </span>
                  )} */}
                </div>
                             
                {/* </>
                                                     )} */}
              </div>
                            </div>
        <button className="access-btn" style={{ width: "100%", height: "initial", marginTop: "20px", padding: "12px", fontSize: "14px" }} onClick={() => navigate(`/view-claim/${element.id}`)}>Access Your Claim</button>
        
          {/* <button className="access-btn" style={{ width: "100%", height: "initial", marginTop: "20px", padding: "12px", fontSize: "14px" }} onClick={() => openAdditonalModal(element)}>Add Sub Claim</button> */}


        {
          otherClaims?.length > 0 && <h3 style={{fontSize:"20px",marginTop:"25px"}}>Sub Claims</h3>
  }

        
        {
          otherClaims?.length > 0 && otherClaims?.map((otherClaim, index) => {

            
            const allAddionalDocs = otherClaim.sub_claims
              .filter(member => member.additional_doc)
              .map(member => ({
                document: member.additional_doc
              }));

            const combinedDocs = [...allAddionalDocs, ...otherClaim.other_doc];
            const totalLength = combinedDocs.length;

            return  <div className="mobile-row" style={{padding:"0",border:"none",marginTop:"20px"}} key={otherClaim.id}>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "8px",
          }}
        >
          <span
            className="claim-id-text"
            style={{
              color: "#222222",
              fontSize: "18px",
              lineHeight: "20px",
              fontWeight: 600,
            }}
          >
            Claim ID: <span className="claim-id">{otherClaim.contact_no}-A{index + 1}</span>
          </span>
          <span className="message-text">
            {" "}
            <span
              style={{
                width: "10px ",
                height: "10px",
                borderRadius: "50%",
                backgroundColor:
                  otherClaim.newMessages > 0 ? "#D04244" : "#E6F6FF",
              }}
                    >
                      
            </span>
            {/* {countArray[index] === 0 ? (
              <div className="dashboard-new-message-container">
                <NewMessageWhiteIcon />
                <span className="sub-header">No new message</span>
              </div>
            ) : (
              <div className="dashboard-new-message-container">
                <MessageRedIcon />
                <span className="sub-header">
                  {countArray[index]} new message
                </span>
              </div>
            )} */}
          </span>
        </div>

        {/* <span
          style={{
            width: "48px",
            height: "48px",
            borderRadius: "50%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            background: "#E8EEF7",
            cursor: "pointer",
          }}
          onClick={() => navigate(`/view-claim/${otherClaim.id}`)}
        >
          <EyeIcon />
        </span> */}
      </div>

      <hr style={{ color: "#CBDAF0" }} />

      <div
        style={{
          display: "flex",
          flexDirection: "column",
          gap: "16px",
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <span className="sub-header">Submitted date</span>

          <span
            style={{ fontSize: "14px", lineHeight: "20px", color: "#222222" }}
          >
            {new Date(otherClaim.created_date).toLocaleDateString("en-US")}
          </span>
          </div>
          
            <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <span className="sub-header">Name</span>

          <span
            style={{ fontSize: "14px", lineHeight: "20px", color: "#222222" }}
          >
            {otherClaim?.first_name} {otherClaim?.last_name}
          </span>
        </div>

        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <span className="sub-header">Claim type</span>

          <span
            style={{
              fontSize: "14px",
              lineHeight: "20px",
              color: "#222222",
              textTransform: "capitalize",
            }}
          >
            {otherClaim?.type_of_claim
              ? getClaimType(otherClaim?.type_of_claim)
              : "-"}
          </span>
        </div>

        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <span className="sub-header">Status</span>

          <span className="mobile-claim-label">
            {
              <span
                style={{
                  textTransform: "capitalize",
                  fontSize: "14px",
                  lineHeight: "20px",
                  borderRadius: "16px",
                  padding: "4px 16px",
                  backgroundColor:
                    otherClaim.status === "In review"
                      ? "rgba(255, 193, 7, 0.1)" // yellow (light)
                      : otherClaim.status === "Waiting for airline"
                      ? "rgba(229, 116, 45, 0.1)" // orange (unchanged)
                      : otherClaim.status === "Documents needed"
                      ? "rgba(208, 66, 68, 0.1)" // red (unchanged)
                      : otherClaim.status === "paid"
                      ? "rgba(33, 150, 243, 0.1)" // blue (light)
                      : otherClaim.status === "approved"
                      ? "rgba(76, 175, 80, 0.1)" // green (optional, since not specified)
                      : otherClaim.status === "appealed"
                      ? "rgba(255, 152, 0, 0.1)" // deep orange
                      : otherClaim.status === "rejected"
                      ? "rgba(244, 67, 54, 0.1)" // red (stronger)
                      : otherClaim.status === "incomplete"
                      ? "rgba(158, 158, 158, 0.1)" // grey
                      : otherClaim.status === "pending"
                      ? "rgba(255, 152, 0, 0.1)" // orange
                      : "rgba(0, 0, 0, 0.1)", // default
                  color:
                    otherClaim.status === "In review"
                      ? "#FFC107" // yellow
                      : otherClaim.status === "Waiting for airline"
                      ? "#E5742D" // orange (unchanged)
                      : otherClaim.status === "Documents needed"
                      ? "#D04244" // red (unchanged)
                      : otherClaim.status === "paid"
                      ? "#2196F3" // blue
                      : otherClaim.status === "approved"
                      ? "#4CAF50" // green
                      : otherClaim.status === "appealed"
                      ? "#FF9800" // deep orange
                      : otherClaim.status === "rejected"
                      ? "#F44336" // red
                      : otherClaim.status === "incomplete"
                      ? "#717171ff" // grey
                      : otherClaim.status === "pending"
                      ? "#FF9800" // orange
                      : "rgba(0, 0, 0, 1)", // default
                }}
              >
                {otherClaim.status}
              </span>
            }
          </span>
        </div>
        {/* {otherClaim.status === "incomplete" && (
          <button
            className="dashboard-edit-button"
            onClick={() => handleEditClick(otherClaim.id)}
          >
            <IconContract size={18} color="#314064" /> Draft
          </button>
        )} */}
      </div>
 {otherClaim.sub_claims.length > 0 ? (
            <>
              <div className="document-wrapper" style={{ width: "fit-content !important" }}>
                 <Tooltip label='View'>
              
                <span
                  onClick={() =>
                    handleViewFile(otherClaim.power_of_attorney)
                  }
                  className="icon"
                  style={{ backgroundColor: "#799DD2" }}
                >
                  <DocumentIcon />
                  </span>
                  
                  </Tooltip>
                <p
                  className="sub-header"
                  style={{ color: "#222222" }}
                >
                  {getShortUpdatedFilename(
                    powerRefs.current[`power_${otherClaim.id}`]?.files?.[0],
                    12
                  ) ||
                    truncateText(otherClaim?.power_of_attorney) ||
                    "No Power of Attorney"}{" "}
                  {/* <span style={{ color: "#858585" }}>(6.7 MB)</span> */}
                </p>
                             
                {/* {!claimData?.power_of_attorney && (
                                                       <>
                                                         {" "} */}
                <div className="signer-status">
                  <input
                    style={{ display: "none" }}
                        ref={(el) => (powerRefs.current[`power_${otherClaim.id}`] = el)}
                    onChange={(e) =>
                      handleUpdatedFileChange(e, "power_of_attorney", otherClaim?.id, otherClaim?.user_id)
                    }
                    type="file"
                    className="form-control mt-2"
                    name="power_of_attorney"
                  />
                    <span
                       onClick={() => powerRefs.current[`power_${otherClaim.id}`]?.click()}
                      
                    className="icon"
                    style={{ border: "1px solid rgb(49, 64, 100)" }}
                  >
                    <svg
                      width="18px"
                      height="18px"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                      <g
                        id="SVGRepo_tracerCarrier"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      ></g>
                      <g id="SVGRepo_iconCarrier">
                        {" "}
                        <path
                          d="M20.1497 7.93997L8.27971 19.81C7.21971 20.88 4.04971 21.3699 3.27971 20.6599C2.50971 19.9499 3.06969 16.78 4.12969 15.71L15.9997 3.84C16.5478 3.31801 17.2783 3.03097 18.0351 3.04019C18.7919 3.04942 19.5151 3.35418 20.0503 3.88938C20.5855 4.42457 20.8903 5.14781 20.8995 5.90463C20.9088 6.66146 20.6217 7.39189 20.0997 7.93997H20.1497Z"
                          stroke="#314064"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        ></path>{" "}
                        <path
                          d="M21 21H12"
                          stroke="#314064"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        ></path>{" "}
                      </g>
                    </svg>
                  </span>

                   <Tooltip label='Sign'>
                                                        
                  
                                                    <span
                                                      className="sign-btn"
                                                      onClick={() => handlePoaSignClick(otherClaim)}
                                                    >
                                                      <svg
                                                        fill="#314064"
                                                        width="20px"
                                                        height="20px"
                                                        viewBox="0 0 56 56"
                                                        xmlns="http://www.w3.org/2000/svg"
                                                      >
                                                        <g
                                                          id="SVGRepo_bgCarrier"
                                                          stroke-width="0"
                                                        ></g>
                                                        <g
                                                          id="SVGRepo_tracerCarrier"
                                                          stroke-linecap="round"
                                                          stroke-linejoin="round"
                                                        ></g>
                                                        <g id="SVGRepo_iconCarrier">
                                                          <path d="M 1.1883 43.4869 L 13.6935 43.4869 C 13.4483 44.4300 13.3162 45.3542 13.3162 46.2030 C 13.3162 49.2397 15.0138 51.4088 18.5786 51.4088 C 22.9168 51.4088 26.4250 48.3532 28.6884 43.4869 L 54.8118 43.4869 C 55.4719 43.4869 56 42.9777 56 42.3175 C 56 41.6574 55.4719 41.1670 54.8118 41.1670 L 29.6315 41.1670 C 30.6877 38.0737 31.3290 34.4523 31.4611 30.5290 C 32.6494 30.2650 33.8941 30.1329 35.1769 30.1329 C 35.8371 30.1329 36.2141 30.4159 36.2141 30.9063 C 36.2141 32.5472 35.3276 33.8298 35.3276 35.4708 C 35.3276 36.9043 36.3841 37.7719 37.7608 37.7719 C 41.5896 37.7719 46.2108 31.2269 47.7385 31.2269 C 49.1342 31.2269 47.3990 37.1117 52.1522 37.1117 C 52.9256 37.1117 53.9253 36.9043 54.6986 36.4139 C 55.1513 36.0932 55.4719 35.6405 55.4719 35.0558 C 55.4719 34.3391 55.0192 33.7544 54.2648 33.7544 C 53.6046 33.7544 53.0577 34.3013 52.4164 34.3013 C 50.3792 34.3013 52.3218 28.0393 48.5687 28.0393 C 45.2868 28.0393 40.1561 34.4145 38.8548 34.4145 C 38.6852 34.4145 38.5531 34.3202 38.5531 34.0939 C 38.5531 33.4149 39.4017 31.8871 39.4017 30.3593 C 39.4017 28.4732 37.8361 27.2660 35.3844 27.2660 C 34.0451 27.2660 32.7248 27.3980 31.4611 27.6432 C 31.0461 17.7032 26.3307 9.8756 19.1256 9.8756 C 14.2782 9.8756 10.5436 14.0063 10.5436 19.2687 C 10.5436 25.4176 14.5423 30.6799 19.5217 34.1693 C 17.3149 36.3384 15.5985 38.8093 14.5423 41.1670 L 1.1883 41.1670 C .5281 41.1670 0 41.6574 0 42.3175 C 0 42.9777 .5281 43.4869 1.1883 43.4869 Z M 13.4106 19.2687 C 13.4106 15.5907 15.9003 12.7426 19.1256 12.7426 C 24.7841 12.7426 28.4432 19.7780 28.6130 28.4166 C 26.0101 29.3219 23.6335 30.6988 21.5776 32.3397 C 17.6544 29.6237 13.4106 25.1347 13.4106 19.2687 Z M .6413 37.1495 C 1.1317 37.6399 1.8673 37.6210 2.3765 37.1495 L 4.7342 34.7918 L 7.0919 37.1495 C 7.5823 37.6399 8.3368 37.6399 8.8272 37.1495 C 9.3176 36.6591 9.3176 35.9046 8.8272 35.4142 L 6.4695 33.0754 L 8.8272 30.7177 C 9.3176 30.2273 9.3176 29.4917 8.8272 29.0012 C 8.3368 28.4920 7.5823 28.5109 7.0919 29.0012 L 4.7342 31.3401 L 2.3765 29.0012 C 1.8673 28.4920 1.1317 28.4920 .6413 29.0012 C .1509 29.4917 .1509 30.2461 .6413 30.7177 L 2.9990 33.0754 L .6413 35.4142 C .1509 35.9235 .1509 36.6591 .6413 37.1495 Z M 23.6335 36.5459 C 23.8787 36.6591 24.1051 36.7156 24.3314 36.7156 C 25.1047 36.7156 25.6517 36.1121 25.6517 35.4708 C 25.6517 34.9992 25.4254 34.5466 24.8784 34.2825 C 24.6143 34.1505 24.3503 34.0184 24.0674 33.8675 C 25.4254 32.9056 26.9343 32.0568 28.5564 31.4155 C 28.3300 35.0558 27.6322 38.4132 26.5571 41.1670 L 17.5790 41.1670 C 18.5597 39.3185 20.0309 37.3758 21.8982 35.6594 C 22.4641 35.9800 23.0488 36.2630 23.6335 36.5459 Z M 16.2586 45.6560 C 16.2586 44.9959 16.3718 44.2603 16.6170 43.4869 L 25.4820 43.4869 C 23.7844 46.6180 21.5022 48.5418 18.8993 48.5418 C 17.0886 48.5418 16.2586 47.3536 16.2586 45.6560 Z"></path>
                                                        </g>
                                                      </svg>
                                                    </span>
                                                        </Tooltip>
                             
                  {/* {element?.power_of_attorney && (
                 <Tooltip label='Download'>

                    <span
                      onClick={() =>
                        handleDownloadClick(
                          element?.power_of_attorney
                        )
                      }
                      className="icon"
                      style={{ border: "1px solid #314064" }}
                    >
                      <DownloadIcon />
                      </span>
                 </Tooltip>
                      
                  )} */}
                </div>
                             
                {/* </>
                                                     )} */}
              </div>
            </>
          ) : "-"}
        

         {/* {otherClaim.sub_claims.length > 0 ? ( */}
            <>
              <div className="document-wrapper" style={{ width: "fit-content !important" }}>
                 <Tooltip label='View'>
                <span
                  onClick={() =>
                    handleViewFile(otherClaim?.airline_poa)
                  }
                  className="icon"
                  style={{ backgroundColor: "#799DD2" }}
                >
                  <DocumentIcon />
                  </span>
                  </Tooltip>
                <p
                  className="sub-header"
                  style={{ color: "#222222" }}
                >
                  {getShortUpdatedFilename(
                     poaRefs.current[`airline_${otherClaim.id}`]?.files?.[0],
                    20
                  ) ||
                    truncateText(otherClaim?.airline_poa) ||
                    "No Airline POA"}{" "}
                  {/* <span style={{ color: "#858585" }}>(6.7 MB)</span> */}
                </p>
                             
                {/* {!claimData?.power_of_attorney && (
                                                       <>
                                                         {" "} */}
                <div className="signer-status">
                  <input
                    style={{ display: "none" }}
                                                                                                      ref={(el) => (poaRefs.current[`airline_${otherClaim.id}`] = el)}


                    onChange={(e) =>
                      handleUpdatedFileChange(e, "airline_poa", otherClaim?.id, otherClaim?.user_id)
                    }
                    type="file"
                    className="form-control mt-2"
                    name="airline_poa"
                  />
                  {/* {!otherClaim?.airline_poa && (
                    <Tooltip label='Edit'>

                   
                  <span
                     onClick={() => poaRefs.current[`airline_${otherClaim.id}`]?.click()}
                    className="icon"
                    style={{ border: "1px solid rgb(49, 64, 100)" }}
                  >
                    <svg
                      width="18px"
                      height="18px"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                      <g
                        id="SVGRepo_tracerCarrier"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      ></g>
                      <g id="SVGRepo_iconCarrier">
                        {" "}
                        <path
                          d="M20.1497 7.93997L8.27971 19.81C7.21971 20.88 4.04971 21.3699 3.27971 20.6599C2.50971 19.9499 3.06969 16.78 4.12969 15.71L15.9997 3.84C16.5478 3.31801 17.2783 3.03097 18.0351 3.04019C18.7919 3.04942 19.5151 3.35418 20.0503 3.88938C20.5855 4.42457 20.8903 5.14781 20.8995 5.90463C20.9088 6.66146 20.6217 7.39189 20.0997 7.93997H20.1497Z"
                          stroke="#314064"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        ></path>{" "}
                        <path
                          d="M21 21H12"
                          stroke="#314064"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        ></path>{" "}
                      </g>
                    </svg>
                      </span>
                      
                       </Tooltip>
                  )} */}
                             
                  {/* {element?.airline_poa && (
                    <Tooltip label='Download'>
                    <span
                      onClick={() =>
                        handleDownloadClick(
                          element?.airline_poa
                        )
                      }
                      className="icon"
                      style={{ border: "1px solid #314064" }}
                    >
                      <DownloadIcon />
                      </span>
                      </Tooltip>
                  )} */}
                </div>
                             
                {/* </>
                                                     )} */}
              </div>
            </>
          {/* ) : "-"} */}
      
      <div style={{marginTop:"16px",display:"flex",flexDirection:"column",gap:"8px"}}>
          <span className="sub-header">Upload Claim Docs</span>
                            <div className="document-wrapper" style={{ width: "fit-content !important" }}>
              
                <p
                  className="sub-header"
                  style={{ color: "#222222" }}
                >
                 {totalLength > 0 ?totalLength :"No"} Documents
                </p>
                             
              
                <div className="signer-status">
                  <input
                    style={{ display: "none" }}
                    ref={addtionalDocumentRef1}
                    onChange={(e) =>
                      handleUploadAddionalFiles(e.target.files,  otherClaim?.id, otherClaim?.user_id)
                    }
                type="file"
                multiple
                    className="form-control mt-2"
                    // name="power_of_attorney"
                  />
                  <span
                    onClick={() => addtionalDocumentRef1.current.click()}
                    className="icon"
                    style={{ border: "1px solid rgb(49, 64, 100)" }}
                  >
                    <svg
                      width="18px"
                      height="18px"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                      <g
                        id="SVGRepo_tracerCarrier"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      ></g>
                      <g id="SVGRepo_iconCarrier">
                        {" "}
                        <path
                          d="M20.1497 7.93997L8.27971 19.81C7.21971 20.88 4.04971 21.3699 3.27971 20.6599C2.50971 19.9499 3.06969 16.78 4.12969 15.71L15.9997 3.84C16.5478 3.31801 17.2783 3.03097 18.0351 3.04019C18.7919 3.04942 19.5151 3.35418 20.0503 3.88938C20.5855 4.42457 20.8903 5.14781 20.8995 5.90463C20.9088 6.66146 20.6217 7.39189 20.0997 7.93997H20.1497Z"
                          stroke="#314064"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        ></path>{" "}
                        <path
                          d="M21 21H12"
                          stroke="#314064"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        ></path>{" "}
                      </g>
                    </svg>
                  </span>
                             
                
                </div>
                             
              
              </div>
                            </div>
        <button className="access-btn" style={{width:"100%",height:"initial",marginTop:"20px",padding:"12px",fontSize:"14px"}}  onClick={() => navigate(`/view-claim/${otherClaim.id}`)}>Access Your Claim</button>
</div>



          })
        }
        

    </div>
  )
  } 
  );

  const rows = data?.map((element, index) => {
const otherClaims = element?.additional_claim || []
   const allAddionalDocs = element.sub_claims
  .filter(member => member.additional_doc)
  .map(member => ({
    document: member.additional_doc
  }));

const combinedDocs = [...allAddionalDocs, ...element.other_doc];

// ✅ Get total length
const totalLength = combinedDocs.length;
    
    return(

    
      <div key={index} style={{background:otherClaims?.length > 0  ? " rgb(244, 248, 255)":"#fff"}} className="table-wrap">
         <div  className="table-row" style={{padding:"0px 20px"}}>
        <span className='table-td table-contact'>{element.unique_claim_id || element.contact_no}</span>
        {/* {element.status === "incomplete" ? (
        <Table.Td className="dashboard-edit-button-container">
          <button
            className="dashboard-edit-button"
            onClick={() => handleEditClick(element.id)}
          >
            <IconContract size={18} color="#314064" /> Draft
          </button>
        </Table.Td>
      ) : ( */}
        {/* <Table.Td>-</Table.Td> */}
        {/* )} */}
        {/* {element.status === "incomplete" && <Link to="/file-claim"><Table.Td>
        edit
      </Table.Td></Link>} */}
        <span className='table-td table-date' >
          {new Date(element.created_date).toLocaleDateString("en-US")}
        </span>
         <span className='table-td table-name' >
         {element?.first_name} {element?.last_name}
        </span>
        
        <span className='table-td table-claim'>
          <span style={{ textTransform: "capitalize" }}>
            {element?.type_of_claim
              ? element?.type_of_claim === "overbooking" ||
                element?.type_of_claim === "denied_boarding"
                ? "Denied Boarding"
                : getClaimType(element?.type_of_claim)
              : "-"}
          </span>
        </span>
        <span className='table-td table-status'>
          {
            <span
              style={{
                textTransform: "capitalize",
                borderRadius: "16px",
                padding: "4px 16px",
                backgroundColor:
                  element.status === "In review"
                    ? "rgba(255, 193, 7, 0.1)" // yellow (light)
                    : element.status === "Waiting for airline"
                      ? "rgba(229, 116, 45, 0.1)" // orange (unchanged)
                      : element.status === "Documents needed"
                        ? "rgba(208, 66, 68, 0.1)" // red (unchanged)
                        : element.status === "paid"
                          ? "rgba(33, 150, 243, 0.1)" // blue (light)
                          : element.status === "approved"
                            ? "rgba(76, 175, 80, 0.1)" // green (optional, since not specified)
                            : element.status === "appealed"
                              ? "rgba(255, 152, 0, 0.1)" // deep orange
                              : element.status === "rejected"
                                ? "rgba(244, 67, 54, 0.1)" // red (stronger)
                                : element.status === "incomplete"
                                  ? "rgba(158, 158, 158, 0.1)" // grey
                                  : element.status === "pending"
                                    ? "rgba(255, 152, 0, 0.1)" // orange
                                    : "rgba(0, 0, 0, 0.1)", // default
                color:
                  element.status === "In review"
                    ? "#FFC107" // yellow
                    : element.status === "Waiting for airline"
                      ? "#E5742D" // orange (unchanged)
                      : element.status === "Documents needed"
                        ? "#D04244" // red (unchanged)
                        : element.status === "paid"
                          ? "#2196F3" // blue
                          : element.status === "approved"
                            ? "#4CAF50" // green
                            : element.status === "appealed"
                              ? "#FF9800" // deep orange
                              : element.status === "rejected"
                                ? "#F44336" // red
                                : element.status === "incomplete"
                                  ? "#9E9E9E" // grey
                                  : element.status === "pending"
                                    ? "#FF9800" // orange
                                    : "rgba(0, 0, 0, 1)", // default
              }}
            >
              {element.status}
            </span>
          }
        </span>
        <span className='table-td table-message'>
          <span>
            <span
              style={{
                width: "10px ",
                height: "10px",
                borderRadius: "50%",
                backgroundColor: element.newMessages > 0 ? "#D04244" : "#E6F6FF",
              }}
            ></span>
            {countArray[index] === 0 ? (
              <div className="dashboard-new-message-container">
                <NewMessageWhiteIcon />
                <span>No message</span>
              </div>
            ) : (
              <div className="dashboard-new-message-container">
                <MessageRedIcon />
                <span>{countArray[index]} message</span>
              </div>
            )}
          </span>
        </span>
        <span className='table-td table-document'>
          {element.sub_claims.length > 0 ? (
            <>
              <div className="document-wrapper" style={{ width: "fit-content !important" }}>
                 <Tooltip label='View'>
              
                <span
                  onClick={() =>
                    handleViewFile(element.power_of_attorney)
                  }
                  className="icon"
                  style={{ backgroundColor: "#799DD2" }}
                >
                  <DocumentIcon />
                  </span>
                  
                  </Tooltip>
                <p
                  className="sub-header"
                  style={{ color: "#222222" }}
                >
                  {getShortUpdatedFilename(
                    powerRefs.current[`power_${element.id}`]?.files?.[0],
                    12
                  ) ||
                    truncateText(element?.power_of_attorney) ||
                    "No Power of Attorney"}{" "}
                  {/* <span style={{ color: "#858585" }}>(6.7 MB)</span> */}
                </p>
                             
                {/* {!claimData?.power_of_attorney && (
                                                       <>
                                                         {" "} */}
                <div className="signer-status">
                  <input
                    style={{ display: "none" }}
                        ref={(el) => (powerRefs.current[`power_${element.id}`] = el)}
                    onChange={(e) =>
                      handleUpdatedFileChange(e, "power_of_attorney", element?.id, element?.user_id)
                    }
                    type="file"
                    className="form-control mt-2"
                    name="power_of_attorney"
                  />
                    <span
                       onClick={() => powerRefs.current[`power_${element.id}`]?.click()}
                      
                    className="icon"
                    style={{ border: "1px solid rgb(49, 64, 100)" }}
                  >
                    <svg
                      width="18px"
                      height="18px"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                      <g
                        id="SVGRepo_tracerCarrier"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      ></g>
                      <g id="SVGRepo_iconCarrier">
                        {" "}
                        <path
                          d="M20.1497 7.93997L8.27971 19.81C7.21971 20.88 4.04971 21.3699 3.27971 20.6599C2.50971 19.9499 3.06969 16.78 4.12969 15.71L15.9997 3.84C16.5478 3.31801 17.2783 3.03097 18.0351 3.04019C18.7919 3.04942 19.5151 3.35418 20.0503 3.88938C20.5855 4.42457 20.8903 5.14781 20.8995 5.90463C20.9088 6.66146 20.6217 7.39189 20.0997 7.93997H20.1497Z"
                          stroke="#314064"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        ></path>{" "}
                        <path
                          d="M21 21H12"
                          stroke="#314064"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        ></path>{" "}
                      </g>
                    </svg>
                  </span>

                   <Tooltip label='Sign'>
                                                        
                  
                                                    <span
                                                      className="sign-btn"
                                                      onClick={() => handlePoaSignClick(element)}
                                                    >
                                                      <svg
                                                        fill="#314064"
                                                        width="20px"
                                                        height="20px"
                                                        viewBox="0 0 56 56"
                                                        xmlns="http://www.w3.org/2000/svg"
                                                      >
                                                        <g
                                                          id="SVGRepo_bgCarrier"
                                                          stroke-width="0"
                                                        ></g>
                                                        <g
                                                          id="SVGRepo_tracerCarrier"
                                                          stroke-linecap="round"
                                                          stroke-linejoin="round"
                                                        ></g>
                                                        <g id="SVGRepo_iconCarrier">
                                                          <path d="M 1.1883 43.4869 L 13.6935 43.4869 C 13.4483 44.4300 13.3162 45.3542 13.3162 46.2030 C 13.3162 49.2397 15.0138 51.4088 18.5786 51.4088 C 22.9168 51.4088 26.4250 48.3532 28.6884 43.4869 L 54.8118 43.4869 C 55.4719 43.4869 56 42.9777 56 42.3175 C 56 41.6574 55.4719 41.1670 54.8118 41.1670 L 29.6315 41.1670 C 30.6877 38.0737 31.3290 34.4523 31.4611 30.5290 C 32.6494 30.2650 33.8941 30.1329 35.1769 30.1329 C 35.8371 30.1329 36.2141 30.4159 36.2141 30.9063 C 36.2141 32.5472 35.3276 33.8298 35.3276 35.4708 C 35.3276 36.9043 36.3841 37.7719 37.7608 37.7719 C 41.5896 37.7719 46.2108 31.2269 47.7385 31.2269 C 49.1342 31.2269 47.3990 37.1117 52.1522 37.1117 C 52.9256 37.1117 53.9253 36.9043 54.6986 36.4139 C 55.1513 36.0932 55.4719 35.6405 55.4719 35.0558 C 55.4719 34.3391 55.0192 33.7544 54.2648 33.7544 C 53.6046 33.7544 53.0577 34.3013 52.4164 34.3013 C 50.3792 34.3013 52.3218 28.0393 48.5687 28.0393 C 45.2868 28.0393 40.1561 34.4145 38.8548 34.4145 C 38.6852 34.4145 38.5531 34.3202 38.5531 34.0939 C 38.5531 33.4149 39.4017 31.8871 39.4017 30.3593 C 39.4017 28.4732 37.8361 27.2660 35.3844 27.2660 C 34.0451 27.2660 32.7248 27.3980 31.4611 27.6432 C 31.0461 17.7032 26.3307 9.8756 19.1256 9.8756 C 14.2782 9.8756 10.5436 14.0063 10.5436 19.2687 C 10.5436 25.4176 14.5423 30.6799 19.5217 34.1693 C 17.3149 36.3384 15.5985 38.8093 14.5423 41.1670 L 1.1883 41.1670 C .5281 41.1670 0 41.6574 0 42.3175 C 0 42.9777 .5281 43.4869 1.1883 43.4869 Z M 13.4106 19.2687 C 13.4106 15.5907 15.9003 12.7426 19.1256 12.7426 C 24.7841 12.7426 28.4432 19.7780 28.6130 28.4166 C 26.0101 29.3219 23.6335 30.6988 21.5776 32.3397 C 17.6544 29.6237 13.4106 25.1347 13.4106 19.2687 Z M .6413 37.1495 C 1.1317 37.6399 1.8673 37.6210 2.3765 37.1495 L 4.7342 34.7918 L 7.0919 37.1495 C 7.5823 37.6399 8.3368 37.6399 8.8272 37.1495 C 9.3176 36.6591 9.3176 35.9046 8.8272 35.4142 L 6.4695 33.0754 L 8.8272 30.7177 C 9.3176 30.2273 9.3176 29.4917 8.8272 29.0012 C 8.3368 28.4920 7.5823 28.5109 7.0919 29.0012 L 4.7342 31.3401 L 2.3765 29.0012 C 1.8673 28.4920 1.1317 28.4920 .6413 29.0012 C .1509 29.4917 .1509 30.2461 .6413 30.7177 L 2.9990 33.0754 L .6413 35.4142 C .1509 35.9235 .1509 36.6591 .6413 37.1495 Z M 23.6335 36.5459 C 23.8787 36.6591 24.1051 36.7156 24.3314 36.7156 C 25.1047 36.7156 25.6517 36.1121 25.6517 35.4708 C 25.6517 34.9992 25.4254 34.5466 24.8784 34.2825 C 24.6143 34.1505 24.3503 34.0184 24.0674 33.8675 C 25.4254 32.9056 26.9343 32.0568 28.5564 31.4155 C 28.3300 35.0558 27.6322 38.4132 26.5571 41.1670 L 17.5790 41.1670 C 18.5597 39.3185 20.0309 37.3758 21.8982 35.6594 C 22.4641 35.9800 23.0488 36.2630 23.6335 36.5459 Z M 16.2586 45.6560 C 16.2586 44.9959 16.3718 44.2603 16.6170 43.4869 L 25.4820 43.4869 C 23.7844 46.6180 21.5022 48.5418 18.8993 48.5418 C 17.0886 48.5418 16.2586 47.3536 16.2586 45.6560 Z"></path>
                                                        </g>
                                                      </svg>
                                                    </span>
                                                        </Tooltip>
                             
                  {/* {element?.power_of_attorney && (
                 <Tooltip label='Download'>

                    <span
                      onClick={() =>
                        handleDownloadClick(
                          element?.power_of_attorney
                        )
                      }
                      className="icon"
                      style={{ border: "1px solid #314064" }}
                    >
                      <DownloadIcon />
                      </span>
                 </Tooltip>
                      
                  )} */}
                </div>
                             
                {/* </>
                                                     )} */}
              </div>
            </>
          ) : "-"}

        </span>


         <span className='table-td table-document'>
          
            <>
              <div className="document-wrapper" style={{ width: "fit-content !important" }}>
                 <Tooltip label='View'>
                <span
                  onClick={() =>
                    handleViewFile(element?.airline_poa)
                  }
                  className="icon"
                  style={{ backgroundColor: "#799DD2" }}
                >
                  <DocumentIcon />
                  </span>
                  </Tooltip>
                <p
                  className="sub-header"
                  style={{ color: "#222222" }}
                >
                  {getShortUpdatedFilename(
                     poaRefs.current[`airline_${element.id}`]?.files?.[0],
                    20
                  ) ||
                    truncateText(element?.airline_poa) ||
                    "No Airline POA"}{" "}
                  {/* <span style={{ color: "#858585" }}>(6.7 MB)</span> */}
                </p>
                             
                {/* {!claimData?.power_of_attorney && (
                                                       <>
                                                         {" "} */}
                <div className="signer-status">
                  <input
                    style={{ display: "none" }}
                                                                                                      ref={(el) => (poaRefs.current[`airline_${element.id}`] = el)}
                                              


                    onChange={(e) =>
                      handleUpdatedFileChange(e, "airline_poa", element?.id, element?.user_id)
                    }
                    type="file"
                    className="form-control mt-2"
                    name="airline_poa"
                  />
                  {!element?.airline_poa && (
                    <Tooltip label='Edit'>

                   
                  <span
                     onClick={() => poaRefs.current[`airline_${element.id}`]?.click()}
                    className="icon"
                    style={{ border: "1px solid rgb(49, 64, 100)" }}
                  >
                    <svg
                      width="18px"
                      height="18px"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                      <g
                        id="SVGRepo_tracerCarrier"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      ></g>
                      <g id="SVGRepo_iconCarrier">
                        {" "}
                        <path
                          d="M20.1497 7.93997L8.27971 19.81C7.21971 20.88 4.04971 21.3699 3.27971 20.6599C2.50971 19.9499 3.06969 16.78 4.12969 15.71L15.9997 3.84C16.5478 3.31801 17.2783 3.03097 18.0351 3.04019C18.7919 3.04942 19.5151 3.35418 20.0503 3.88938C20.5855 4.42457 20.8903 5.14781 20.8995 5.90463C20.9088 6.66146 20.6217 7.39189 20.0997 7.93997H20.1497Z"
                          stroke="#314064"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        ></path>{" "}
                        <path
                          d="M21 21H12"
                          stroke="#314064"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        ></path>{" "}
                      </g>
                    </svg>
                      </span>
                      
                       </Tooltip>
                  )}
                             
                  {/* {element?.airline_poa && (
                    <Tooltip label='Download'>
                    <span
                      onClick={() =>
                        handleDownloadClick(
                          element?.airline_poa
                        )
                      }
                      className="icon"
                      style={{ border: "1px solid #314064" }}
                    >
                      <DownloadIcon />
                      </span>
                      </Tooltip>
                  )} */}
                </div>
                             
                {/* </>
                                                     )} */}
              </div>
            </>
         

        </span>


      
        <span className='table-td table-document'>
         
              <div className="document-wrapper" style={{ width: "fit-content !important" }}>
              
                <p
                  className="sub-header"
                  style={{ color: "#222222" }}
                >
                 {totalLength > 0 ?totalLength :"No"} Documents
                </p>
                             
              
                <div className="signer-status">
                  <input
                    style={{ display: "none" }}
                                      ref={(el) => (additiionalFileRefs.current[`additional_${element.id}`] = el)}

                    onChange={(e) =>
                      handleUploadAddionalFiles(e.target.files,  element?.id, element?.user_id)
                    }
                type="file"
                multiple
                    className="form-control mt-2"
                    // name="power_of_attorney"
              />
              <Tooltip label='Edit'>
                  <span
                                      onClick={() => additiionalFileRefs.current[`additional_${element.id}`]?.click()}

                    className="icon"
                    style={{ border: "1px solid rgb(49, 64, 100)" }}
                  >
                    <svg
                      width="18px"
                      height="18px"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                      <g
                        id="SVGRepo_tracerCarrier"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      ></g>
                      <g id="SVGRepo_iconCarrier">
                        {" "}
                        <path
                          d="M20.1497 7.93997L8.27971 19.81C7.21971 20.88 4.04971 21.3699 3.27971 20.6599C2.50971 19.9499 3.06969 16.78 4.12969 15.71L15.9997 3.84C16.5478 3.31801 17.2783 3.03097 18.0351 3.04019C18.7919 3.04942 19.5151 3.35418 20.0503 3.88938C20.5855 4.42457 20.8903 5.14781 20.8995 5.90463C20.9088 6.66146 20.6217 7.39189 20.0997 7.93997H20.1497Z"
                          stroke="#314064"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        ></path>{" "}
                        <path
                          d="M21 21H12"
                          stroke="#314064"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        ></path>{" "}
                      </g>
                    </svg>
                </span>
                
                </Tooltip>
                             
                  {/* {element?.power_of_attorney && (
                    <span
                      onClick={() =>
                        handleDownloadClick(
                          element?.power_of_attorney
                        )
                      }
                      className="icon"
                      style={{ border: "1px solid #314064" }}
                    >
                      <DownloadIcon />
                    </span>
                  )} */}
                </div>
                             
                {/* </>
                                                     )} */}
              </div>
            
          

        </span>
        <span className='table-td table-buttons' >
       
          <button className="access-btn" onClick={() => navigate(`/view-claim/${element.id}`)}>Access Your Claim</button>

             <button className="access-btn" onClick={() => openAdditonalModal(element)}>Add Sub Claim</button>

        
       
       
        
          {/* <EyeIcon
          onClick={() => navigate(`/view-claim/${element.id}`)}
          style={{ cursor: "pointer", width: "23px", height: "23px" }}
        /> */}
        </span>

       
     
        </div>
        {
          otherClaims?.length > 0 && <div style={{padding:"10px 20px",fontWeight:"700"}} colSpan={999}>Sub Claims</div>
          
        }
        {
          otherClaims?.length > 0 && otherClaims?.map((otherClaim, index) => {

            
     const allAddionalDocs = otherClaim.sub_claims
  .filter(member => member.additional_doc)
  .map(member => ({
    document: member.additional_doc
  }));

const combinedDocs = [...allAddionalDocs, ...otherClaim.other_doc];
const totalLength = combinedDocs.length;

            return <>
             
             <div className="table-row"  >
                <span className='table-td table-contact'>{otherClaim.contact_no}-A{index + 1}</span>
        {/* {element.status === "incomplete" ? (
        <Table.Td className="dashboard-edit-button-container">
          <button
            className="dashboard-edit-button"
            onClick={() => handleEditClick(element.id)}
          >
            <IconContract size={18} color="#314064" /> Draft
          </button>
        </Table.Td>
      ) : ( */}
        {/* <Table.Td>-</Table.Td> */}
        {/* )} */}
        {/* {element.status === "incomplete" && <Link to="/file-claim"><Table.Td>
        edit
      </Table.Td></Link>} */}
        <span className='table-td table-date'>
          {new Date(otherClaim.created_date).toLocaleDateString("en-US")}
        </span>
         <span className='table-td table-name' >
         {otherClaim?.first_name} {otherClaim?.last_name}
        </span>
        
        <span className='table-td table-claim'>
          <span style={{ textTransform: "capitalize" }}>
            {otherClaim?.type_of_claim
              ? getClaimType(otherClaim?.type_of_claim)
              : "-"}
          </span>
        </span>
        <span className='table-td table-status'>
          {
            <span
              style={{
                textTransform: "capitalize",
                borderRadius: "16px",
                padding: "4px 16px",
                backgroundColor:
                  otherClaim.status === "In review"
                    ? "rgba(255, 193, 7, 0.1)" // yellow (light)
                    : otherClaim.status === "Waiting for airline"
                      ? "rgba(229, 116, 45, 0.1)" // orange (unchanged)
                      : otherClaim.status === "Documents needed"
                        ? "rgba(208, 66, 68, 0.1)" // red (unchanged)
                        : otherClaim.status === "paid"
                          ? "rgba(33, 150, 243, 0.1)" // blue (light)
                          : otherClaim.status === "approved"
                            ? "rgba(76, 175, 80, 0.1)" // green (optional, since not specified)
                            : otherClaim.status === "appealed"
                              ? "rgba(255, 152, 0, 0.1)" // deep orange
                              : otherClaim.status === "rejected"
                                ? "rgba(244, 67, 54, 0.1)" // red (stronger)
                                : otherClaim.status === "incomplete"
                                  ? "rgba(158, 158, 158, 0.1)" // grey
                                  : otherClaim.status === "pending"
                                    ? "rgba(255, 152, 0, 0.1)" // orange
                                    : "rgba(0, 0, 0, 0.1)", // default
                color:
                  otherClaim.status === "In review"
                    ? "#FFC107" // yellow
                    : otherClaim.status === "Waiting for airline"
                      ? "#E5742D" // orange (unchanged)
                      : otherClaim.status === "Documents needed"
                        ? "#D04244" // red (unchanged)
                        : otherClaim.status === "paid"
                          ? "#2196F3" // blue
                          : otherClaim.status === "approved"
                            ? "#4CAF50" // green
                            : otherClaim.status === "appealed"
                              ? "#FF9800" // deep orange
                              : otherClaim.status === "rejected"
                                ? "#F44336" // red
                                : otherClaim.status === "incomplete"
                                  ? "#9E9E9E" // grey
                                  : otherClaim.status === "pending"
                                    ? "#FF9800" // orange
                                    : "rgba(0, 0, 0, 1)", // default
              }}
            >
              {otherClaim.status}
            </span>
          }
        </span>
        <span className='table-td table-message'>
          {/* <span>
            <span
              style={{
                width: "10px ",
                height: "10px",
                borderRadius: "50%",
                backgroundColor: element.newMessages > 0 ? "#D04244" : "#E6F6FF",
              }}
            ></span>
            {countArray[index] === 0 ? (
              <div className="dashboard-new-message-container">
                <NewMessageWhiteIcon />
                <span>No new message</span>
              </div>
            ) : (
              <div className="dashboard-new-message-container">
                <MessageRedIcon />
                <span>{countArray[index]} new message</span>
              </div>
            )}
          </span> */}
                  -
        </span>
        <span className='table-td table-document'>
            {otherClaim.sub_claims.length > 0 ? (
            <>
              <div className="document-wrapper" style={{ width: "fit-content !important" }}>
                 <Tooltip label='View'>
              
                <span
                  onClick={() =>
                    handleViewFile(otherClaim.power_of_attorney)
                  }
                  className="icon"
                  style={{ backgroundColor: "#799DD2" }}
                >
                  <DocumentIcon />
                  </span>
                  
                  </Tooltip>
                <p
                  className="sub-header"
                  style={{ color: "#222222" }}
                >
                  {getShortUpdatedFilename(
                    powerRefs.current[`power_${otherClaim.id}`]?.files?.[0],
                    12
                  ) ||
                    truncateText(otherClaim?.power_of_attorney) ||
                    "No Power of Attorney"}{" "}
                  {/* <span style={{ color: "#858585" }}>(6.7 MB)</span> */}
                </p>
                             
                {/* {!claimData?.power_of_attorney && (
                                                       <>
                                                         {" "} */}
                <div className="signer-status">
                  <input
                    style={{ display: "none" }}
                        ref={(el) => (powerRefs.current[`power_${otherClaim.id}`] = el)}
                    onChange={(e) =>
                      handleUpdatedFileChange(e, "power_of_attorney", otherClaim?.id, otherClaim?.user_id)
                    }
                    type="file"
                    className="form-control mt-2"
                    name="power_of_attorney"
                  />
                    <span
                       onClick={() => powerRefs.current[`power_${otherClaim.id}`]?.click()}
                      
                    className="icon"
                    style={{ border: "1px solid rgb(49, 64, 100)" }}
                  >
                    <svg
                      width="18px"
                      height="18px"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                      <g
                        id="SVGRepo_tracerCarrier"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      ></g>
                      <g id="SVGRepo_iconCarrier">
                        {" "}
                        <path
                          d="M20.1497 7.93997L8.27971 19.81C7.21971 20.88 4.04971 21.3699 3.27971 20.6599C2.50971 19.9499 3.06969 16.78 4.12969 15.71L15.9997 3.84C16.5478 3.31801 17.2783 3.03097 18.0351 3.04019C18.7919 3.04942 19.5151 3.35418 20.0503 3.88938C20.5855 4.42457 20.8903 5.14781 20.8995 5.90463C20.9088 6.66146 20.6217 7.39189 20.0997 7.93997H20.1497Z"
                          stroke="#314064"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        ></path>{" "}
                        <path
                          d="M21 21H12"
                          stroke="#314064"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        ></path>{" "}
                      </g>
                    </svg>
                  </span>

                   <Tooltip label='Sign'>
                                                        
                  
                                                    <span
                                                      className="sign-btn"
                                                      onClick={() => handlePoaSignClick(otherClaim)}
                                                    >
                                                      <svg
                                                        fill="#314064"
                                                        width="20px"
                                                        height="20px"
                                                        viewBox="0 0 56 56"
                                                        xmlns="http://www.w3.org/2000/svg"
                                                      >
                                                        <g
                                                          id="SVGRepo_bgCarrier"
                                                          stroke-width="0"
                                                        ></g>
                                                        <g
                                                          id="SVGRepo_tracerCarrier"
                                                          stroke-linecap="round"
                                                          stroke-linejoin="round"
                                                        ></g>
                                                        <g id="SVGRepo_iconCarrier">
                                                          <path d="M 1.1883 43.4869 L 13.6935 43.4869 C 13.4483 44.4300 13.3162 45.3542 13.3162 46.2030 C 13.3162 49.2397 15.0138 51.4088 18.5786 51.4088 C 22.9168 51.4088 26.4250 48.3532 28.6884 43.4869 L 54.8118 43.4869 C 55.4719 43.4869 56 42.9777 56 42.3175 C 56 41.6574 55.4719 41.1670 54.8118 41.1670 L 29.6315 41.1670 C 30.6877 38.0737 31.3290 34.4523 31.4611 30.5290 C 32.6494 30.2650 33.8941 30.1329 35.1769 30.1329 C 35.8371 30.1329 36.2141 30.4159 36.2141 30.9063 C 36.2141 32.5472 35.3276 33.8298 35.3276 35.4708 C 35.3276 36.9043 36.3841 37.7719 37.7608 37.7719 C 41.5896 37.7719 46.2108 31.2269 47.7385 31.2269 C 49.1342 31.2269 47.3990 37.1117 52.1522 37.1117 C 52.9256 37.1117 53.9253 36.9043 54.6986 36.4139 C 55.1513 36.0932 55.4719 35.6405 55.4719 35.0558 C 55.4719 34.3391 55.0192 33.7544 54.2648 33.7544 C 53.6046 33.7544 53.0577 34.3013 52.4164 34.3013 C 50.3792 34.3013 52.3218 28.0393 48.5687 28.0393 C 45.2868 28.0393 40.1561 34.4145 38.8548 34.4145 C 38.6852 34.4145 38.5531 34.3202 38.5531 34.0939 C 38.5531 33.4149 39.4017 31.8871 39.4017 30.3593 C 39.4017 28.4732 37.8361 27.2660 35.3844 27.2660 C 34.0451 27.2660 32.7248 27.3980 31.4611 27.6432 C 31.0461 17.7032 26.3307 9.8756 19.1256 9.8756 C 14.2782 9.8756 10.5436 14.0063 10.5436 19.2687 C 10.5436 25.4176 14.5423 30.6799 19.5217 34.1693 C 17.3149 36.3384 15.5985 38.8093 14.5423 41.1670 L 1.1883 41.1670 C .5281 41.1670 0 41.6574 0 42.3175 C 0 42.9777 .5281 43.4869 1.1883 43.4869 Z M 13.4106 19.2687 C 13.4106 15.5907 15.9003 12.7426 19.1256 12.7426 C 24.7841 12.7426 28.4432 19.7780 28.6130 28.4166 C 26.0101 29.3219 23.6335 30.6988 21.5776 32.3397 C 17.6544 29.6237 13.4106 25.1347 13.4106 19.2687 Z M .6413 37.1495 C 1.1317 37.6399 1.8673 37.6210 2.3765 37.1495 L 4.7342 34.7918 L 7.0919 37.1495 C 7.5823 37.6399 8.3368 37.6399 8.8272 37.1495 C 9.3176 36.6591 9.3176 35.9046 8.8272 35.4142 L 6.4695 33.0754 L 8.8272 30.7177 C 9.3176 30.2273 9.3176 29.4917 8.8272 29.0012 C 8.3368 28.4920 7.5823 28.5109 7.0919 29.0012 L 4.7342 31.3401 L 2.3765 29.0012 C 1.8673 28.4920 1.1317 28.4920 .6413 29.0012 C .1509 29.4917 .1509 30.2461 .6413 30.7177 L 2.9990 33.0754 L .6413 35.4142 C .1509 35.9235 .1509 36.6591 .6413 37.1495 Z M 23.6335 36.5459 C 23.8787 36.6591 24.1051 36.7156 24.3314 36.7156 C 25.1047 36.7156 25.6517 36.1121 25.6517 35.4708 C 25.6517 34.9992 25.4254 34.5466 24.8784 34.2825 C 24.6143 34.1505 24.3503 34.0184 24.0674 33.8675 C 25.4254 32.9056 26.9343 32.0568 28.5564 31.4155 C 28.3300 35.0558 27.6322 38.4132 26.5571 41.1670 L 17.5790 41.1670 C 18.5597 39.3185 20.0309 37.3758 21.8982 35.6594 C 22.4641 35.9800 23.0488 36.2630 23.6335 36.5459 Z M 16.2586 45.6560 C 16.2586 44.9959 16.3718 44.2603 16.6170 43.4869 L 25.4820 43.4869 C 23.7844 46.6180 21.5022 48.5418 18.8993 48.5418 C 17.0886 48.5418 16.2586 47.3536 16.2586 45.6560 Z"></path>
                                                        </g>
                                                      </svg>
                                                    </span>
                                                        </Tooltip>
                             
                  {/* {element?.power_of_attorney && (
                 <Tooltip label='Download'>

                    <span
                      onClick={() =>
                        handleDownloadClick(
                          element?.power_of_attorney
                        )
                      }
                      className="icon"
                      style={{ border: "1px solid #314064" }}
                    >
                      <DownloadIcon />
                      </span>
                 </Tooltip>
                      
                  )} */}
                </div>
                             
                {/* </>
                                                     )} */}
              </div>
            </>
          ) : "-"}


        </span>


         <span className='table-td table-document'>
           {/* {otherClaim.sub_claims.length > 0 ? ( */}
            <>
              <div className="document-wrapper" style={{ width: "fit-content !important" }}>
                 <Tooltip label='View'>
                <span
                  onClick={() =>
                    handleViewFile(otherClaim?.airline_poa)
                  }
                  className="icon"
                  style={{ backgroundColor: "#799DD2" }}
                >
                  <DocumentIcon />
                  </span>
                  </Tooltip>
                <p
                  className="sub-header"
                  style={{ color: "#222222" }}
                >
                  {getShortUpdatedFilename(
                     poaRefs.current[`airline_${otherClaim.id}`]?.files?.[0],
                    20
                  ) ||
                    truncateText(otherClaim?.airline_poa) ||
                    "No Airline POA"}{" "}
                  {/* <span style={{ color: "#858585" }}>(6.7 MB)</span> */}
                </p>
                             
                {/* {!claimData?.power_of_attorney && (
                                                       <>
                                                         {" "} */}
                <div className="signer-status">
                  <input
                    style={{ display: "none" }}
                                                                                                      ref={(el) => (poaRefs.current[`airline_${otherClaim.id}`] = el)}


                    onChange={(e) =>
                      handleUpdatedFileChange(e, "airline_poa", otherClaim?.id, otherClaim?.user_id)
                    }
                    type="file"
                    className="form-control mt-2"
                    name="airline_poa"
                  />
                  {/* {!otherClaim?.airline_poa && (
                    <Tooltip label='Edit'>

                   
                  <span
                     onClick={() => poaRefs.current[`airline_${otherClaim.id}`]?.click()}
                    className="icon"
                    style={{ border: "1px solid rgb(49, 64, 100)" }}
                  >
                    <svg
                      width="18px"
                      height="18px"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                      <g
                        id="SVGRepo_tracerCarrier"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      ></g>
                      <g id="SVGRepo_iconCarrier">
                        {" "}
                        <path
                          d="M20.1497 7.93997L8.27971 19.81C7.21971 20.88 4.04971 21.3699 3.27971 20.6599C2.50971 19.9499 3.06969 16.78 4.12969 15.71L15.9997 3.84C16.5478 3.31801 17.2783 3.03097 18.0351 3.04019C18.7919 3.04942 19.5151 3.35418 20.0503 3.88938C20.5855 4.42457 20.8903 5.14781 20.8995 5.90463C20.9088 6.66146 20.6217 7.39189 20.0997 7.93997H20.1497Z"
                          stroke="#314064"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        ></path>{" "}
                        <path
                          d="M21 21H12"
                          stroke="#314064"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        ></path>{" "}
                      </g>
                    </svg>
                      </span>
                      
                       </Tooltip>
                  )} */}
                             
                  {/* {element?.airline_poa && (
                    <Tooltip label='Download'>
                    <span
                      onClick={() =>
                        handleDownloadClick(
                          element?.airline_poa
                        )
                      }
                      className="icon"
                      style={{ border: "1px solid #314064" }}
                    >
                      <DownloadIcon />
                      </span>
                      </Tooltip>
                  )} */}
                </div>
                             
                {/* </>
                                                     )} */}
              </div>
            </>
          {/* ) : "-"} */}
        </span>


      
        <span className='table-td table-document'>
         
              <div className="document-wrapper" style={{ width: "fit-content !important" }}>
              
                <p
                  className="sub-header"
                  style={{ color: "#222222" }}
                >
                 {totalLength > 0 ?totalLength :"No"} Documents
                </p>
                             
              
                <div className="signer-status">
                  <input
                    style={{ display: "none" }}
                    ref={addtionalDocumentRef1}
                    onChange={(e) =>
                      handleUploadAddionalFiles(e.target.files,  otherClaim?.id, otherClaim?.user_id)
                    }
                type="file"
                multiple
                    className="form-control mt-2"
                    // name="power_of_attorney"
              />
              <Tooltip label='Edit'>
                  <span
                    onClick={() => addtionalDocumentRef1.current.click()}
                    className="icon"
                    style={{ border: "1px solid rgb(49, 64, 100)" }}
                  >
                    <svg
                      width="18px"
                      height="18px"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                      <g
                        id="SVGRepo_tracerCarrier"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      ></g>
                      <g id="SVGRepo_iconCarrier">
                        {" "}
                        <path
                          d="M20.1497 7.93997L8.27971 19.81C7.21971 20.88 4.04971 21.3699 3.27971 20.6599C2.50971 19.9499 3.06969 16.78 4.12969 15.71L15.9997 3.84C16.5478 3.31801 17.2783 3.03097 18.0351 3.04019C18.7919 3.04942 19.5151 3.35418 20.0503 3.88938C20.5855 4.42457 20.8903 5.14781 20.8995 5.90463C20.9088 6.66146 20.6217 7.39189 20.0997 7.93997H20.1497Z"
                          stroke="#314064"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        ></path>{" "}
                        <path
                          d="M21 21H12"
                          stroke="#314064"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        ></path>{" "}
                      </g>
                    </svg>
                </span>
                
                </Tooltip>
                             
                  {/* {element?.power_of_attorney && (
                    <span
                      onClick={() =>
                        handleDownloadClick(
                          element?.power_of_attorney
                        )
                      }
                      className="icon"
                      style={{ border: "1px solid #314064" }}
                    >
                      <DownloadIcon />
                    </span>
                  )} */}
                </div>
                             
                {/* </>
                                                     )} */}
              </div>
            
          

        </span>
        <span className='table-td table-buttons'>
       
          <button className="access-btn" onClick={() => navigate(`/view-claim/${otherClaim.id}`)}>Access Your Claim</button>

        
       
       
        
          {/* <EyeIcon
          onClick={() => navigate(`/view-claim/${element.id}`)}
          style={{ cursor: "pointer", width: "23px", height: "23px" }}
        /> */}
        </span>

                <span></span>

        
     
        </div>
            </> 
          })
        }
        

      </div>
     
    )
  });


    const groupRows = groupClaimData?.map((element, index) => {
const otherClaims = element?.additional_claim || []
   const allAddionalDocs = element.sub_claims
  .filter(member => member.additional_doc)
  .map(member => ({
    document: member.additional_doc
  }));

const combinedDocs = [...allAddionalDocs, ...element.other_doc];

// ✅ Get total length
const totalLength = combinedDocs.length;
    
    return(

    
      <div key={index} style={{background:otherClaims?.length > 0  ? " rgb(244, 248, 255)":"#fff"}} className="table-wrap">
         <div  className="table-row" style={{padding:"0px 20px"}}>
        <span className='table-td table-contact'>{element.unique_claim_id || element.contact_no}</span>
        {/* {element.status === "incomplete" ? (
        <Table.Td className="dashboard-edit-button-container">
          <button
            className="dashboard-edit-button"
            onClick={() => handleEditClick(element.id)}
          >
            <IconContract size={18} color="#314064" /> Draft
          </button>
        </Table.Td>
      ) : ( */}
        {/* <Table.Td>-</Table.Td> */}
        {/* )} */}
        {/* {element.status === "incomplete" && <Link to="/file-claim"><Table.Td>
        edit
      </Table.Td></Link>} */}
        <span className='table-td table-date' >
          {new Date(element.created_date).toLocaleDateString("en-US")}
        </span>
         <span className='table-td tabel-group-name' >
         {element?.group_name}
        </span>
        
        <span className='table-td table-claim'>
          <span style={{ textTransform: "capitalize" }}>
            {element?.type_of_claim
              ? element?.type_of_claim === "overbooking" ||
                element?.type_of_claim === "denied_boarding"
                ? "Denied Boarding"
                : getClaimType(element?.type_of_claim)
              : "-"}
          </span>
        </span>
        <span className='table-td table-status'>
          {
            <span
              style={{
                textTransform: "capitalize",
                borderRadius: "16px",
                padding: "4px 16px",
                backgroundColor:
                  element.status === "In review"
                    ? "rgba(255, 193, 7, 0.1)" // yellow (light)
                    : element.status === "Waiting for airline"
                      ? "rgba(229, 116, 45, 0.1)" // orange (unchanged)
                      : element.status === "Documents needed"
                        ? "rgba(208, 66, 68, 0.1)" // red (unchanged)
                        : element.status === "paid"
                          ? "rgba(33, 150, 243, 0.1)" // blue (light)
                          : element.status === "approved"
                            ? "rgba(76, 175, 80, 0.1)" // green (optional, since not specified)
                            : element.status === "appealed"
                              ? "rgba(255, 152, 0, 0.1)" // deep orange
                              : element.status === "rejected"
                                ? "rgba(244, 67, 54, 0.1)" // red (stronger)
                                : element.status === "incomplete"
                                  ? "rgba(158, 158, 158, 0.1)" // grey
                                  : element.status === "pending"
                                    ? "rgba(255, 152, 0, 0.1)" // orange
                                    : "rgba(0, 0, 0, 0.1)", // default
                color:
                  element.status === "In review"
                    ? "#FFC107" // yellow
                    : element.status === "Waiting for airline"
                      ? "#E5742D" // orange (unchanged)
                      : element.status === "Documents needed"
                        ? "#D04244" // red (unchanged)
                        : element.status === "paid"
                          ? "#2196F3" // blue
                          : element.status === "approved"
                            ? "#4CAF50" // green
                            : element.status === "appealed"
                              ? "#FF9800" // deep orange
                              : element.status === "rejected"
                                ? "#F44336" // red
                                : element.status === "incomplete"
                                  ? "#9E9E9E" // grey
                                  : element.status === "pending"
                                    ? "#FF9800" // orange
                                    : "rgba(0, 0, 0, 1)", // default
              }}
            >
              {element.status}
            </span>
          }
        </span>
        <span className='table-td table-message'>
          <span>
            <span
              style={{
                width: "10px ",
                height: "10px",
                borderRadius: "50%",
                backgroundColor: element.newMessages > 0 ? "#D04244" : "#E6F6FF",
              }}
            ></span>
            {countArray[index] === 0 ? (
              <div className="dashboard-new-message-container">
                <NewMessageWhiteIcon />
                <span>No message</span>
              </div>
            ) : (
              <div className="dashboard-new-message-container">
                <MessageRedIcon />
                <span>{countArray[index]} message</span>
              </div>
            )}
          </span>
        </span>
        <span className='table-td table-document'>
         {element.sub_claims.length > 0 ? (
            <>
              <div className="document-wrapper" style={{ width: "fit-content !important" }}>
                 <Tooltip label='View'>
              
                <span
                  onClick={() =>
                    handleViewFile(element.power_of_attorney)
                  }
                  className="icon"
                  style={{ backgroundColor: "#799DD2" }}
                >
                  <DocumentIcon />
                  </span>
                  
                  </Tooltip>
                <p
                  className="sub-header"
                  style={{ color: "#222222" }}
                >
                  {getShortUpdatedFilename(
                    powerRefs.current[`power_${element.id}`]?.files?.[0],
                    12
                  ) ||
                    truncateText(element?.power_of_attorney) ||
                    "No Power of Attorney"}{" "}
                  {/* <span style={{ color: "#858585" }}>(6.7 MB)</span> */}
                </p>
                             
                {/* {!claimData?.power_of_attorney && (
                                                       <>
                                                         {" "} */}
                <div className="signer-status">
                  <input
                    style={{ display: "none" }}
                        ref={(el) => (powerRefs.current[`power_${element.id}`] = el)}
                    onChange={(e) =>
                      handleUpdatedFileChange(e, "power_of_attorney", element?.id, element?.user_id)
                    }
                    type="file"
                    className="form-control mt-2"
                    name="power_of_attorney"
                  />
                    <span
                       onClick={() => powerRefs.current[`power_${element.id}`]?.click()}
                      
                    className="icon"
                    style={{ border: "1px solid rgb(49, 64, 100)" }}
                  >
                    <svg
                      width="18px"
                      height="18px"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                      <g
                        id="SVGRepo_tracerCarrier"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      ></g>
                      <g id="SVGRepo_iconCarrier">
                        {" "}
                        <path
                          d="M20.1497 7.93997L8.27971 19.81C7.21971 20.88 4.04971 21.3699 3.27971 20.6599C2.50971 19.9499 3.06969 16.78 4.12969 15.71L15.9997 3.84C16.5478 3.31801 17.2783 3.03097 18.0351 3.04019C18.7919 3.04942 19.5151 3.35418 20.0503 3.88938C20.5855 4.42457 20.8903 5.14781 20.8995 5.90463C20.9088 6.66146 20.6217 7.39189 20.0997 7.93997H20.1497Z"
                          stroke="#314064"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        ></path>{" "}
                        <path
                          d="M21 21H12"
                          stroke="#314064"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        ></path>{" "}
                      </g>
                    </svg>
                  </span>

                   <Tooltip label='Sign'>
                                                        
                  
                                                    <span
                                                      className="sign-btn"
                                                      onClick={() => handlePoaSignClick(element)}
                                                    >
                                                      <svg
                                                        fill="#314064"
                                                        width="20px"
                                                        height="20px"
                                                        viewBox="0 0 56 56"
                                                        xmlns="http://www.w3.org/2000/svg"
                                                      >
                                                        <g
                                                          id="SVGRepo_bgCarrier"
                                                          stroke-width="0"
                                                        ></g>
                                                        <g
                                                          id="SVGRepo_tracerCarrier"
                                                          stroke-linecap="round"
                                                          stroke-linejoin="round"
                                                        ></g>
                                                        <g id="SVGRepo_iconCarrier">
                                                          <path d="M 1.1883 43.4869 L 13.6935 43.4869 C 13.4483 44.4300 13.3162 45.3542 13.3162 46.2030 C 13.3162 49.2397 15.0138 51.4088 18.5786 51.4088 C 22.9168 51.4088 26.4250 48.3532 28.6884 43.4869 L 54.8118 43.4869 C 55.4719 43.4869 56 42.9777 56 42.3175 C 56 41.6574 55.4719 41.1670 54.8118 41.1670 L 29.6315 41.1670 C 30.6877 38.0737 31.3290 34.4523 31.4611 30.5290 C 32.6494 30.2650 33.8941 30.1329 35.1769 30.1329 C 35.8371 30.1329 36.2141 30.4159 36.2141 30.9063 C 36.2141 32.5472 35.3276 33.8298 35.3276 35.4708 C 35.3276 36.9043 36.3841 37.7719 37.7608 37.7719 C 41.5896 37.7719 46.2108 31.2269 47.7385 31.2269 C 49.1342 31.2269 47.3990 37.1117 52.1522 37.1117 C 52.9256 37.1117 53.9253 36.9043 54.6986 36.4139 C 55.1513 36.0932 55.4719 35.6405 55.4719 35.0558 C 55.4719 34.3391 55.0192 33.7544 54.2648 33.7544 C 53.6046 33.7544 53.0577 34.3013 52.4164 34.3013 C 50.3792 34.3013 52.3218 28.0393 48.5687 28.0393 C 45.2868 28.0393 40.1561 34.4145 38.8548 34.4145 C 38.6852 34.4145 38.5531 34.3202 38.5531 34.0939 C 38.5531 33.4149 39.4017 31.8871 39.4017 30.3593 C 39.4017 28.4732 37.8361 27.2660 35.3844 27.2660 C 34.0451 27.2660 32.7248 27.3980 31.4611 27.6432 C 31.0461 17.7032 26.3307 9.8756 19.1256 9.8756 C 14.2782 9.8756 10.5436 14.0063 10.5436 19.2687 C 10.5436 25.4176 14.5423 30.6799 19.5217 34.1693 C 17.3149 36.3384 15.5985 38.8093 14.5423 41.1670 L 1.1883 41.1670 C .5281 41.1670 0 41.6574 0 42.3175 C 0 42.9777 .5281 43.4869 1.1883 43.4869 Z M 13.4106 19.2687 C 13.4106 15.5907 15.9003 12.7426 19.1256 12.7426 C 24.7841 12.7426 28.4432 19.7780 28.6130 28.4166 C 26.0101 29.3219 23.6335 30.6988 21.5776 32.3397 C 17.6544 29.6237 13.4106 25.1347 13.4106 19.2687 Z M .6413 37.1495 C 1.1317 37.6399 1.8673 37.6210 2.3765 37.1495 L 4.7342 34.7918 L 7.0919 37.1495 C 7.5823 37.6399 8.3368 37.6399 8.8272 37.1495 C 9.3176 36.6591 9.3176 35.9046 8.8272 35.4142 L 6.4695 33.0754 L 8.8272 30.7177 C 9.3176 30.2273 9.3176 29.4917 8.8272 29.0012 C 8.3368 28.4920 7.5823 28.5109 7.0919 29.0012 L 4.7342 31.3401 L 2.3765 29.0012 C 1.8673 28.4920 1.1317 28.4920 .6413 29.0012 C .1509 29.4917 .1509 30.2461 .6413 30.7177 L 2.9990 33.0754 L .6413 35.4142 C .1509 35.9235 .1509 36.6591 .6413 37.1495 Z M 23.6335 36.5459 C 23.8787 36.6591 24.1051 36.7156 24.3314 36.7156 C 25.1047 36.7156 25.6517 36.1121 25.6517 35.4708 C 25.6517 34.9992 25.4254 34.5466 24.8784 34.2825 C 24.6143 34.1505 24.3503 34.0184 24.0674 33.8675 C 25.4254 32.9056 26.9343 32.0568 28.5564 31.4155 C 28.3300 35.0558 27.6322 38.4132 26.5571 41.1670 L 17.5790 41.1670 C 18.5597 39.3185 20.0309 37.3758 21.8982 35.6594 C 22.4641 35.9800 23.0488 36.2630 23.6335 36.5459 Z M 16.2586 45.6560 C 16.2586 44.9959 16.3718 44.2603 16.6170 43.4869 L 25.4820 43.4869 C 23.7844 46.6180 21.5022 48.5418 18.8993 48.5418 C 17.0886 48.5418 16.2586 47.3536 16.2586 45.6560 Z"></path>
                                                        </g>
                                                      </svg>
                                                    </span>
                                                        </Tooltip>
                             
                  {/* {element?.power_of_attorney && (
                 <Tooltip label='Download'>

                    <span
                      onClick={() =>
                        handleDownloadClick(
                          element?.power_of_attorney
                        )
                      }
                      className="icon"
                      style={{ border: "1px solid #314064" }}
                    >
                      <DownloadIcon />
                      </span>
                 </Tooltip>
                      
                  )} */}
                </div>
                             
                {/* </>
                                                     )} */}
              </div>
            </>
          ) : "-"}

        </span>


         <span className='table-td table-document'>
          {/* {element.sub_claims.length > 0 ? ( */}
            <>
              <div className="document-wrapper" style={{ width: "fit-content !important" }}>
                 <Tooltip label='View'>
                <span
                  onClick={() =>
                    handleViewFile(element?.airline_poa)
                  }
                  className="icon"
                  style={{ backgroundColor: "#799DD2" }}
                >
                  <DocumentIcon />
                  </span>
                  </Tooltip>
                <p
                  className="sub-header"
                  style={{ color: "#222222" }}
                >
                  {getShortUpdatedFilename(
                     poaRefs.current[`airline_${element.id}`]?.files?.[0],
                    20
                  ) ||
                    truncateText(element?.airline_poa) ||
                    "No Airline POA"}{" "}
                  {/* <span style={{ color: "#858585" }}>(6.7 MB)</span> */}
                </p>
                             
                {/* {!claimData?.power_of_attorney && (
                                                       <>
                                                         {" "} */}
                <div className="signer-status">
                  <input
                    style={{ display: "none" }}
                                                                                                      ref={(el) => (poaRefs.current[`airline_${element.id}`] = el)}


                    onChange={(e) =>
                      handleUpdatedFileChange(e, "airline_poa", element?.id, element?.user_id)
                    }
                    type="file"
                    className="form-control mt-2"
                    name="airline_poa"
                  />
                  {/* {!element?.airline_poa && (
                    <Tooltip label='Edit'>

                   
                  <span
                     onClick={() => poaRefs.current[`airline_${element.id}`]?.click()}
                    className="icon"
                    style={{ border: "1px solid rgb(49, 64, 100)" }}
                  >
                    <svg
                      width="18px"
                      height="18px"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                      <g
                        id="SVGRepo_tracerCarrier"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      ></g>
                      <g id="SVGRepo_iconCarrier">
                        {" "}
                        <path
                          d="M20.1497 7.93997L8.27971 19.81C7.21971 20.88 4.04971 21.3699 3.27971 20.6599C2.50971 19.9499 3.06969 16.78 4.12969 15.71L15.9997 3.84C16.5478 3.31801 17.2783 3.03097 18.0351 3.04019C18.7919 3.04942 19.5151 3.35418 20.0503 3.88938C20.5855 4.42457 20.8903 5.14781 20.8995 5.90463C20.9088 6.66146 20.6217 7.39189 20.0997 7.93997H20.1497Z"
                          stroke="#314064"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        ></path>{" "}
                        <path
                          d="M21 21H12"
                          stroke="#314064"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        ></path>{" "}
                      </g>
                    </svg>
                      </span>
                      
                       </Tooltip>
                  )} */}
                             
                  {/* {element?.airline_poa && (
                    <Tooltip label='Download'>
                    <span
                      onClick={() =>
                        handleDownloadClick(
                          element?.airline_poa
                        )
                      }
                      className="icon"
                      style={{ border: "1px solid #314064" }}
                    >
                      <DownloadIcon />
                      </span>
                      </Tooltip>
                  )} */}
                </div>
                             
                {/* </>
                                                     )} */}
              </div>
            </>
          {/* ) : "-"} */}

        </span>


      
        <span className='table-td table-document'>
         
              <div className="document-wrapper" style={{ width: "fit-content !important" }}>
              
                <p
                  className="sub-header"
                  style={{ color: "#222222" }}
                >
                 {totalLength > 0 ?totalLength :"No"} Documents
                </p>
                             
              
                <div className="signer-status">
                  <input
                    style={{ display: "none" }}
                                      ref={(el) => (additiionalFileRefs.current[`additional_${element.id}`] = el)}

                    onChange={(e) =>
                      handleUploadAddionalFiles(e.target.files,  element?.id, element?.user_id)
                    }
                type="file"
                multiple
                    className="form-control mt-2"
                    // name="power_of_attorney"
              />
              <Tooltip label='Edit'>
                  <span
                                      onClick={() => additiionalFileRefs.current[`additional_${element.id}`]?.click()}

                    className="icon"
                    style={{ border: "1px solid rgb(49, 64, 100)" }}
                  >
                    <svg
                      width="18px"
                      height="18px"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                      <g
                        id="SVGRepo_tracerCarrier"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      ></g>
                      <g id="SVGRepo_iconCarrier">
                        {" "}
                        <path
                          d="M20.1497 7.93997L8.27971 19.81C7.21971 20.88 4.04971 21.3699 3.27971 20.6599C2.50971 19.9499 3.06969 16.78 4.12969 15.71L15.9997 3.84C16.5478 3.31801 17.2783 3.03097 18.0351 3.04019C18.7919 3.04942 19.5151 3.35418 20.0503 3.88938C20.5855 4.42457 20.8903 5.14781 20.8995 5.90463C20.9088 6.66146 20.6217 7.39189 20.0997 7.93997H20.1497Z"
                          stroke="#314064"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        ></path>{" "}
                        <path
                          d="M21 21H12"
                          stroke="#314064"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        ></path>{" "}
                      </g>
                    </svg>
                </span>
                
                </Tooltip>
                             
                  {/* {element?.power_of_attorney && (
                    <span
                      onClick={() =>
                        handleDownloadClick(
                          element?.power_of_attorney
                        )
                      }
                      className="icon"
                      style={{ border: "1px solid #314064" }}
                    >
                      <DownloadIcon />
                    </span>
                  )} */}
                </div>
                             
                {/* </>
                                                     )} */}
              </div>
            
          

        </span>
        <span className='table-td table-buttons'>
       
          <button className="access-btn" onClick={() => navigate(`/view-claim/${element.id}`)}>Access Your Claim</button>

             {/* <button className="access-btn" onClick={() => openAdditonalModal(element)}>Add Sub Claim</button> */}

        
       
       
        
          {/* <EyeIcon
          onClick={() => navigate(`/view-claim/${element.id}`)}
          style={{ cursor: "pointer", width: "23px", height: "23px" }}
        /> */}
        </span>

       
     
        </div>
        {
          otherClaims?.length > 0 && <div style={{padding:"10px 20px",fontWeight:"700"}} colSpan={999}>Sub Claims</div>
          
        }
        {
          otherClaims?.length > 0 && otherClaims?.map((otherClaim, index) => {

            
     const allAddionalDocs = otherClaim.sub_claims
  .filter(member => member.additional_doc)
  .map(member => ({
    document: member.additional_doc
  }));

const combinedDocs = [...allAddionalDocs, ...otherClaim.other_doc];
const totalLength = combinedDocs.length;

            return <>
             
             <div className="table-row"  >
                <span className='table-td table-contact'>{otherClaim.contact_no}-A{index + 1}</span>
        {/* {element.status === "incomplete" ? (
        <Table.Td className="dashboard-edit-button-container">
          <button
            className="dashboard-edit-button"
            onClick={() => handleEditClick(element.id)}
          >
            <IconContract size={18} color="#314064" /> Draft
          </button>
        </Table.Td>
      ) : ( */}
        {/* <Table.Td>-</Table.Td> */}
        {/* )} */}
        {/* {element.status === "incomplete" && <Link to="/file-claim"><Table.Td>
        edit
      </Table.Td></Link>} */}
        <span className='table-td table-date'>
          {new Date(otherClaim.created_date).toLocaleDateString("en-US")}
        </span>
         <span className='table-td table-name' >
         {otherClaim?.first_name} {otherClaim?.last_name}
        </span>
        
        <span className='table-td table-claim'>
          <span style={{ textTransform: "capitalize" }}>
            {otherClaim?.type_of_claim
              ? getClaimType(otherClaim?.type_of_claim)
              : "-"}
          </span>
        </span>
        <span className='table-td table-status'>
          {
            <span
              style={{
                textTransform: "capitalize",
                borderRadius: "16px",
                padding: "4px 16px",
                backgroundColor:
                  otherClaim.status === "In review"
                    ? "rgba(255, 193, 7, 0.1)" // yellow (light)
                    : otherClaim.status === "Waiting for airline"
                      ? "rgba(229, 116, 45, 0.1)" // orange (unchanged)
                      : otherClaim.status === "Documents needed"
                        ? "rgba(208, 66, 68, 0.1)" // red (unchanged)
                        : otherClaim.status === "paid"
                          ? "rgba(33, 150, 243, 0.1)" // blue (light)
                          : otherClaim.status === "approved"
                            ? "rgba(76, 175, 80, 0.1)" // green (optional, since not specified)
                            : otherClaim.status === "appealed"
                              ? "rgba(255, 152, 0, 0.1)" // deep orange
                              : otherClaim.status === "rejected"
                                ? "rgba(244, 67, 54, 0.1)" // red (stronger)
                                : otherClaim.status === "incomplete"
                                  ? "rgba(158, 158, 158, 0.1)" // grey
                                  : otherClaim.status === "pending"
                                    ? "rgba(255, 152, 0, 0.1)" // orange
                                    : "rgba(0, 0, 0, 0.1)", // default
                color:
                  otherClaim.status === "In review"
                    ? "#FFC107" // yellow
                    : otherClaim.status === "Waiting for airline"
                      ? "#E5742D" // orange (unchanged)
                      : otherClaim.status === "Documents needed"
                        ? "#D04244" // red (unchanged)
                        : otherClaim.status === "paid"
                          ? "#2196F3" // blue
                          : otherClaim.status === "approved"
                            ? "#4CAF50" // green
                            : otherClaim.status === "appealed"
                              ? "#FF9800" // deep orange
                              : otherClaim.status === "rejected"
                                ? "#F44336" // red
                                : otherClaim.status === "incomplete"
                                  ? "#9E9E9E" // grey
                                  : otherClaim.status === "pending"
                                    ? "#FF9800" // orange
                                    : "rgba(0, 0, 0, 1)", // default
              }}
            >
              {otherClaim.status}
            </span>
          }
        </span>
        <span className='table-td table-message'>
          {/* <span>
            <span
              style={{
                width: "10px ",
                height: "10px",
                borderRadius: "50%",
                backgroundColor: element.newMessages > 0 ? "#D04244" : "#E6F6FF",
              }}
            ></span>
            {countArray[index] === 0 ? (
              <div className="dashboard-new-message-container">
                <NewMessageWhiteIcon />
                <span>No new message</span>
              </div>
            ) : (
              <div className="dashboard-new-message-container">
                <MessageRedIcon />
                <span>{countArray[index]} new message</span>
              </div>
            )}
          </span> */}
                  -
        </span>
        <span className='table-td table-document'>
         {otherClaim.sub_claims.length > 0 ? (
            <>
              <div className="document-wrapper" style={{ width: "fit-content !important" }}>
                 <Tooltip label='View'>
              
                <span
                  onClick={() =>
                    handleViewFile(otherClaim.power_of_attorney)
                  }
                  className="icon"
                  style={{ backgroundColor: "#799DD2" }}
                >
                  <DocumentIcon />
                  </span>
                  
                  </Tooltip>
                <p
                  className="sub-header"
                  style={{ color: "#222222" }}
                >
                  {getShortUpdatedFilename(
                    powerRefs.current[`power_${otherClaim.id}`]?.files?.[0],
                    12
                  ) ||
                    truncateText(otherClaim?.power_of_attorney) ||
                    "No Power of Attorney"}{" "}
                  {/* <span style={{ color: "#858585" }}>(6.7 MB)</span> */}
                </p>
                             
                {/* {!claimData?.power_of_attorney && (
                                                       <>
                                                         {" "} */}
                <div className="signer-status">
                  <input
                    style={{ display: "none" }}
                        ref={(el) => (powerRefs.current[`power_${otherClaim.id}`] = el)}
                    onChange={(e) =>
                      handleUpdatedFileChange(e, "power_of_attorney", otherClaim?.id, otherClaim?.user_id)
                    }
                    type="file"
                    className="form-control mt-2"
                    name="power_of_attorney"
                  />
                    <span
                       onClick={() => powerRefs.current[`power_${otherClaim.id}`]?.click()}
                      
                    className="icon"
                    style={{ border: "1px solid rgb(49, 64, 100)" }}
                  >
                    <svg
                      width="18px"
                      height="18px"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                      <g
                        id="SVGRepo_tracerCarrier"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      ></g>
                      <g id="SVGRepo_iconCarrier">
                        {" "}
                        <path
                          d="M20.1497 7.93997L8.27971 19.81C7.21971 20.88 4.04971 21.3699 3.27971 20.6599C2.50971 19.9499 3.06969 16.78 4.12969 15.71L15.9997 3.84C16.5478 3.31801 17.2783 3.03097 18.0351 3.04019C18.7919 3.04942 19.5151 3.35418 20.0503 3.88938C20.5855 4.42457 20.8903 5.14781 20.8995 5.90463C20.9088 6.66146 20.6217 7.39189 20.0997 7.93997H20.1497Z"
                          stroke="#314064"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        ></path>{" "}
                        <path
                          d="M21 21H12"
                          stroke="#314064"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        ></path>{" "}
                      </g>
                    </svg>
                  </span>

                   <Tooltip label='Sign'>
                                                        
                  
                                                    <span
                                                      className="sign-btn"
                                                      onClick={() => handlePoaSignClick(otherClaim)}
                                                    >
                                                      <svg
                                                        fill="#314064"
                                                        width="20px"
                                                        height="20px"
                                                        viewBox="0 0 56 56"
                                                        xmlns="http://www.w3.org/2000/svg"
                                                      >
                                                        <g
                                                          id="SVGRepo_bgCarrier"
                                                          stroke-width="0"
                                                        ></g>
                                                        <g
                                                          id="SVGRepo_tracerCarrier"
                                                          stroke-linecap="round"
                                                          stroke-linejoin="round"
                                                        ></g>
                                                        <g id="SVGRepo_iconCarrier">
                                                          <path d="M 1.1883 43.4869 L 13.6935 43.4869 C 13.4483 44.4300 13.3162 45.3542 13.3162 46.2030 C 13.3162 49.2397 15.0138 51.4088 18.5786 51.4088 C 22.9168 51.4088 26.4250 48.3532 28.6884 43.4869 L 54.8118 43.4869 C 55.4719 43.4869 56 42.9777 56 42.3175 C 56 41.6574 55.4719 41.1670 54.8118 41.1670 L 29.6315 41.1670 C 30.6877 38.0737 31.3290 34.4523 31.4611 30.5290 C 32.6494 30.2650 33.8941 30.1329 35.1769 30.1329 C 35.8371 30.1329 36.2141 30.4159 36.2141 30.9063 C 36.2141 32.5472 35.3276 33.8298 35.3276 35.4708 C 35.3276 36.9043 36.3841 37.7719 37.7608 37.7719 C 41.5896 37.7719 46.2108 31.2269 47.7385 31.2269 C 49.1342 31.2269 47.3990 37.1117 52.1522 37.1117 C 52.9256 37.1117 53.9253 36.9043 54.6986 36.4139 C 55.1513 36.0932 55.4719 35.6405 55.4719 35.0558 C 55.4719 34.3391 55.0192 33.7544 54.2648 33.7544 C 53.6046 33.7544 53.0577 34.3013 52.4164 34.3013 C 50.3792 34.3013 52.3218 28.0393 48.5687 28.0393 C 45.2868 28.0393 40.1561 34.4145 38.8548 34.4145 C 38.6852 34.4145 38.5531 34.3202 38.5531 34.0939 C 38.5531 33.4149 39.4017 31.8871 39.4017 30.3593 C 39.4017 28.4732 37.8361 27.2660 35.3844 27.2660 C 34.0451 27.2660 32.7248 27.3980 31.4611 27.6432 C 31.0461 17.7032 26.3307 9.8756 19.1256 9.8756 C 14.2782 9.8756 10.5436 14.0063 10.5436 19.2687 C 10.5436 25.4176 14.5423 30.6799 19.5217 34.1693 C 17.3149 36.3384 15.5985 38.8093 14.5423 41.1670 L 1.1883 41.1670 C .5281 41.1670 0 41.6574 0 42.3175 C 0 42.9777 .5281 43.4869 1.1883 43.4869 Z M 13.4106 19.2687 C 13.4106 15.5907 15.9003 12.7426 19.1256 12.7426 C 24.7841 12.7426 28.4432 19.7780 28.6130 28.4166 C 26.0101 29.3219 23.6335 30.6988 21.5776 32.3397 C 17.6544 29.6237 13.4106 25.1347 13.4106 19.2687 Z M .6413 37.1495 C 1.1317 37.6399 1.8673 37.6210 2.3765 37.1495 L 4.7342 34.7918 L 7.0919 37.1495 C 7.5823 37.6399 8.3368 37.6399 8.8272 37.1495 C 9.3176 36.6591 9.3176 35.9046 8.8272 35.4142 L 6.4695 33.0754 L 8.8272 30.7177 C 9.3176 30.2273 9.3176 29.4917 8.8272 29.0012 C 8.3368 28.4920 7.5823 28.5109 7.0919 29.0012 L 4.7342 31.3401 L 2.3765 29.0012 C 1.8673 28.4920 1.1317 28.4920 .6413 29.0012 C .1509 29.4917 .1509 30.2461 .6413 30.7177 L 2.9990 33.0754 L .6413 35.4142 C .1509 35.9235 .1509 36.6591 .6413 37.1495 Z M 23.6335 36.5459 C 23.8787 36.6591 24.1051 36.7156 24.3314 36.7156 C 25.1047 36.7156 25.6517 36.1121 25.6517 35.4708 C 25.6517 34.9992 25.4254 34.5466 24.8784 34.2825 C 24.6143 34.1505 24.3503 34.0184 24.0674 33.8675 C 25.4254 32.9056 26.9343 32.0568 28.5564 31.4155 C 28.3300 35.0558 27.6322 38.4132 26.5571 41.1670 L 17.5790 41.1670 C 18.5597 39.3185 20.0309 37.3758 21.8982 35.6594 C 22.4641 35.9800 23.0488 36.2630 23.6335 36.5459 Z M 16.2586 45.6560 C 16.2586 44.9959 16.3718 44.2603 16.6170 43.4869 L 25.4820 43.4869 C 23.7844 46.6180 21.5022 48.5418 18.8993 48.5418 C 17.0886 48.5418 16.2586 47.3536 16.2586 45.6560 Z"></path>
                                                        </g>
                                                      </svg>
                                                    </span>
                                                        </Tooltip>
                             
                  {/* {element?.power_of_attorney && (
                 <Tooltip label='Download'>

                    <span
                      onClick={() =>
                        handleDownloadClick(
                          element?.power_of_attorney
                        )
                      }
                      className="icon"
                      style={{ border: "1px solid #314064" }}
                    >
                      <DownloadIcon />
                      </span>
                 </Tooltip>
                      
                  )} */}
                </div>
                             
                {/* </>
                                                     )} */}
              </div>
            </>
          ) : "-"}

        </span>


         <span className='table-td table-document'>
          {/* {otherClaim.sub_claims.length > 0 ? ( */}
            <>
              <div className="document-wrapper" style={{ width: "fit-content !important" }}>
                 <Tooltip label='View'>
                <span
                  onClick={() =>
                    handleViewFile(otherClaim?.airline_poa)
                  }
                  className="icon"
                  style={{ backgroundColor: "#799DD2" }}
                >
                  <DocumentIcon />
                  </span>
                  </Tooltip>
                <p
                  className="sub-header"
                  style={{ color: "#222222" }}
                >
                  {getShortUpdatedFilename(
                     poaRefs.current[`airline_${otherClaim.id}`]?.files?.[0],
                    20
                  ) ||
                    truncateText(otherClaim?.airline_poa) ||
                    "No Airline POA"}{" "}
                  {/* <span style={{ color: "#858585" }}>(6.7 MB)</span> */}
                </p>
                             
                {/* {!claimData?.power_of_attorney && (
                                                       <>
                                                         {" "} */}
                <div className="signer-status">
                  <input
                    style={{ display: "none" }}
                                                                                                      ref={(el) => (poaRefs.current[`airline_${otherClaim.id}`] = el)}


                    onChange={(e) =>
                      handleUpdatedFileChange(e, "airline_poa", otherClaim?.id, otherClaim?.user_id)
                    }
                    type="file"
                    className="form-control mt-2"
                    name="airline_poa"
                  />
                  {/* {!otherClaim?.airline_poa && (
                    <Tooltip label='Edit'>

                   
                  <span
                     onClick={() => poaRefs.current[`airline_${otherClaim.id}`]?.click()}
                    className="icon"
                    style={{ border: "1px solid rgb(49, 64, 100)" }}
                  >
                    <svg
                      width="18px"
                      height="18px"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                      <g
                        id="SVGRepo_tracerCarrier"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      ></g>
                      <g id="SVGRepo_iconCarrier">
                        {" "}
                        <path
                          d="M20.1497 7.93997L8.27971 19.81C7.21971 20.88 4.04971 21.3699 3.27971 20.6599C2.50971 19.9499 3.06969 16.78 4.12969 15.71L15.9997 3.84C16.5478 3.31801 17.2783 3.03097 18.0351 3.04019C18.7919 3.04942 19.5151 3.35418 20.0503 3.88938C20.5855 4.42457 20.8903 5.14781 20.8995 5.90463C20.9088 6.66146 20.6217 7.39189 20.0997 7.93997H20.1497Z"
                          stroke="#314064"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        ></path>{" "}
                        <path
                          d="M21 21H12"
                          stroke="#314064"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        ></path>{" "}
                      </g>
                    </svg>
                      </span>
                      
                       </Tooltip>
                  )} */}
                             
                  {/* {element?.airline_poa && (
                    <Tooltip label='Download'>
                    <span
                      onClick={() =>
                        handleDownloadClick(
                          element?.airline_poa
                        )
                      }
                      className="icon"
                      style={{ border: "1px solid #314064" }}
                    >
                      <DownloadIcon />
                      </span>
                      </Tooltip>
                  )} */}
                </div>
                             
                {/* </>
                                                     )} */}
              </div>
            </>
          {/* ) : "-"} */}

        </span>


      
        <span className='table-td table-document'>
         
              <div className="document-wrapper" style={{ width: "fit-content !important" }}>
              
                <p
                  className="sub-header"
                  style={{ color: "#222222" }}
                >
                 {totalLength > 0 ?totalLength :"No"} Documents
                </p>
                             
              
                <div className="signer-status">
                  <input
                    style={{ display: "none" }}
                    ref={addtionalDocumentRef1}
                    onChange={(e) =>
                      handleUploadAddionalFiles(e.target.files,  otherClaim?.id, otherClaim?.user_id)
                    }
                type="file"
                multiple
                    className="form-control mt-2"
                    // name="power_of_attorney"
              />
              <Tooltip label='Edit'>
                  <span
                    onClick={() => addtionalDocumentRef1.current.click()}
                    className="icon"
                    style={{ border: "1px solid rgb(49, 64, 100)" }}
                  >
                    <svg
                      width="18px"
                      height="18px"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                      <g
                        id="SVGRepo_tracerCarrier"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      ></g>
                      <g id="SVGRepo_iconCarrier">
                        {" "}
                        <path
                          d="M20.1497 7.93997L8.27971 19.81C7.21971 20.88 4.04971 21.3699 3.27971 20.6599C2.50971 19.9499 3.06969 16.78 4.12969 15.71L15.9997 3.84C16.5478 3.31801 17.2783 3.03097 18.0351 3.04019C18.7919 3.04942 19.5151 3.35418 20.0503 3.88938C20.5855 4.42457 20.8903 5.14781 20.8995 5.90463C20.9088 6.66146 20.6217 7.39189 20.0997 7.93997H20.1497Z"
                          stroke="#314064"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        ></path>{" "}
                        <path
                          d="M21 21H12"
                          stroke="#314064"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        ></path>{" "}
                      </g>
                    </svg>
                </span>
                
                </Tooltip>
                             
                  {/* {element?.power_of_attorney && (
                    <span
                      onClick={() =>
                        handleDownloadClick(
                          element?.power_of_attorney
                        )
                      }
                      className="icon"
                      style={{ border: "1px solid #314064" }}
                    >
                      <DownloadIcon />
                    </span>
                  )} */}
                </div>
                             
                {/* </>
                                                     )} */}
              </div>
            
          

        </span>
        <span className='table-td table-buttons'>
       
          <button className="access-btn" onClick={() => navigate(`/view-claim/${otherClaim.id}`)}>Access Your Claim</button>

        
       
       
        
          {/* <EyeIcon
          onClick={() => navigate(`/view-claim/${element.id}`)}
          style={{ cursor: "pointer", width: "23px", height: "23px" }}
        /> */}
        </span>

                <span></span>

        
     
        </div>
            </> 
          })
        }
        

      </div>
     
    )
  });

  return (
    <div>
      <Nav totalMessageCount={totalMessageCount} />
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={backdropopen}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
 <Modal
              opened={openAdditionalModal}
              onClose={() => setOpenAdditonalModal(false)}
        size={window.innerWidth > 768 ? "90%":"100%"} title='Addtional Claim' fullScreen={window.innerWidth < 768 }>
        
        <AdditionalClaim claim={additonalMainClaim} setOpenAdditonalModal={setOpenAdditonalModal} setbackdropopen={setbackdropopen} setUpdatedPOA={setUpdatedPOA} />
        </Modal>

      <Modal
        opened={lufthansaPoaModalOpen}
        onClose={() => {
          setLufthansaPoaModalOpen(false);
          setSignedPoaFile(null);
          setPoaUploadError("");
          setSelectedLufthansaClaim(null);
        }}
        closeOnClickOutside={false}
        withCloseButton={true}
        centered
        radius={"lg"}
        padding={"xl"}
        size={"lg"}
      >
        <div style={{ display: "flex", flexDirection: "column", gap: "20px" }}>
          <div style={{ textAlign: "center" }}>
            <h4 style={{ color: "#314064", marginBottom: "8px", fontWeight: 700 }}>
              Physical Signature Required (Lufthansa)
            </h4>
            <p style={{ color: "#666", fontSize: "14px", lineHeight: "1.5", margin: 0 }}>
              Your claim involves a <strong>Lufthansa</strong> flight. German law and jurisdiction require a physically signed (wet-ink signature) Power of Attorney. Digital signatures are not permitted for this airline.
            </p>
          </div>

          {/* Step 1: Download Section */}
          <div
            style={{
              backgroundColor: "#f8f9fa",
              border: "1px solid #e9ecef",
              borderRadius: "10px",
              padding: "16px",
            }}
          >
            <div
              style={{
                fontWeight: 600,
                color: "#314064",
                marginBottom: "12px",
                fontSize: "14px",
              }}
            >
              Step 1: Download Unsigned Document to Print
            </div>
            <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  flexWrap: "wrap",
                  gap: "10px",
                  padding: "10px 14px",
                  backgroundColor: "#fff",
                  borderRadius: "8px",
                  border: "1px solid #dee2e6",
                }}
              >
                <div>
                  <div style={{ fontWeight: 600, fontSize: "14px", color: "#212529" }}>
                    Power of Attorney
                  </div>
                  <div style={{ fontSize: "12px", color: "#6c757d" }}>
                    German Power of Attorney PDF
                  </div>
                </div>
                <CustomButton
                  btnText={"Download PDF"}
                  onClick={() =>
                    handleDownloadPoa(
                      selectedLufthansaClaim?.power_of_attorney ||
                        selectedLufthansaClaim?.airline_poa
                    )
                  }
                  style={{ width: "auto" }}
                />
              </div>
            </div>
          </div>

          {/* Step 2: Instructions */}
          <div
            style={{
              backgroundColor: "#e7f3ff",
              border: "1px solid #b6d4fe",
              borderRadius: "10px",
              padding: "14px 16px",
            }}
          >
            <div
              style={{
                fontWeight: 600,
                color: "#084298",
                fontSize: "14px",
                marginBottom: "4px",
              }}
            >
              Step 2: Print & Sign
            </div>
            <div style={{ fontSize: "13px", color: "#084298", lineHeight: "1.4" }}>
              Print the downloaded document and sign physically by hand using ink on the signature line.
            </div>
          </div>

          {/* Step 3: Upload Section */}
          <div
            style={{
              backgroundColor: "#f8f9fa",
              border: "1px solid #e9ecef",
              borderRadius: "10px",
              padding: "16px",
            }}
          >
            <div
              style={{
                fontWeight: 600,
                color: "#314064",
                marginBottom: "12px",
                fontSize: "14px",
              }}
            >
              Step 3: Upload Signed Document
            </div>
            <div style={{ display: "flex", flexDirection: "column", gap: "14px" }}>
              <div>
                <label
                  style={{
                    display: "block",
                    fontSize: "13px",
                    fontWeight: 600,
                    color: "#495057",
                    marginBottom: "6px",
                  }}
                >
                  Upload Signed Power of Attorney <span style={{ color: "red" }}>*</span>
                </label>
                <input
                  type="file"
                  accept="application/pdf,image/*"
                  onChange={(e) => {
                    if (e.target.files && e.target.files[0]) {
                      setSignedPoaFile(e.target.files[0]);
                      setPoaUploadError("");
                    }
                  }}
                  style={{
                    display: "block",
                    width: "100%",
                    padding: "8px 12px",
                    fontSize: "14px",
                    border: "1px solid #ced4da",
                    borderRadius: "6px",
                    backgroundColor: "#fff",
                  }}
                />
                {signedPoaFile && (
                  <div style={{ fontSize: "12px", color: "#28a745", marginTop: "4px" }}>
                    ✓ Selected: {signedPoaFile.name} ({(signedPoaFile.size / 1024).toFixed(1)} KB)
                  </div>
                )}
              </div>

              {poaUploadError && (
                <div style={{ color: "#dc3545", fontSize: "13px", fontWeight: 500 }}>
                  {poaUploadError}
                </div>
              )}
            </div>
          </div>

          {/* Modal Actions */}
          <div style={{ display: "flex", justifyContent: "flex-end", gap: "12px", marginTop: "10px" }}>
            <CustomButton
              btnText={"Close / Upload Later"}
              type="secondary"
              onClick={() => {
                setLufthansaPoaModalOpen(false);
                setSignedPoaFile(null);
                setPoaUploadError("");
                setSelectedLufthansaClaim(null);
              }}
              style={{ width: "auto" }}
            />
            <CustomButton
              btnText={"Submit Signed Documents"}
              onClick={handleSubmitLufthansaPoa}
              disabled={!signedPoaFile}
              style={{ width: "auto" }}
            />
          </div>
        </div>
      </Modal>

       <Modal
              opened={openSignerModal}
              onClose={() => setOpenSignerModal(false)}
              size={window.innerWidth < 768 ? "100%" : "40%"}
        fullScreen={window.innerWidth < 768} title='Signer Details'>
        {/* <h1 style={{fontSize:"24px",padding:"10px",marginBottom:"40px"}}>Signer Details</h1> */}
         <div style={{display:"flex",flexDirection:"column",gap:"10px",minHeight:"50vh"}}>
                             {signerDetails &&
                               signerDetails.length > 0 &&
                               signerDetails.map((signer, index) => (
                                 <div className="signer-box" key={index} style={{width:"100%"}}>
                                   <div className="signer-details">
                                     <span className="signer-icon">
                                       {signer?.name.slice(0, 1).toUpperCase()}
                                     </span>
                                     <span className="signer-name">
                                       {getSignerName(signer?.name)}
                                     </span>
                                   </div>
       
                                   <div className="signer-status">
                                     {signer?.signed ? (
                                       <span className="signed-success">Signed</span>
                                     ) : (
                                         <>
                                            <Tooltip label='Check Status'>
                                           
                                         <span
                                           className="sign-btn"
                                           onClick={() => handleCheckStatus(signer)}
                                         >
                                          <svg width="20px" height="20px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M3.67981 11.3333H2.92981H3.67981ZM3.67981 13L3.15157 13.5324C3.44398 13.8225 3.91565 13.8225 4.20805 13.5324L3.67981 13ZM5.88787 11.8657C6.18191 11.574 6.18377 11.0991 5.89203 10.8051C5.60029 10.511 5.12542 10.5092 4.83138 10.8009L5.88787 11.8657ZM2.52824 10.8009C2.2342 10.5092 1.75933 10.511 1.46759 10.8051C1.17585 11.0991 1.17772 11.574 1.47176 11.8657L2.52824 10.8009ZM18.6156 7.39279C18.8325 7.74565 19.2944 7.85585 19.6473 7.63892C20.0001 7.42199 20.1103 6.96007 19.8934 6.60721L18.6156 7.39279ZM12.0789 2.25C7.03155 2.25 2.92981 6.3112 2.92981 11.3333H4.42981C4.42981 7.15072 7.84884 3.75 12.0789 3.75V2.25ZM2.92981 11.3333L2.92981 13H4.42981L4.42981 11.3333H2.92981ZM4.20805 13.5324L5.88787 11.8657L4.83138 10.8009L3.15157 12.4676L4.20805 13.5324ZM4.20805 12.4676L2.52824 10.8009L1.47176 11.8657L3.15157 13.5324L4.20805 12.4676ZM19.8934 6.60721C18.287 3.99427 15.3873 2.25 12.0789 2.25V3.75C14.8484 3.75 17.2727 5.20845 18.6156 7.39279L19.8934 6.60721Z" fill="#222222"></path> <path d="M20.3139 11L20.8411 10.4666C20.549 10.1778 20.0788 10.1778 19.7867 10.4666L20.3139 11ZM18.1004 12.1333C17.8058 12.4244 17.8031 12.8993 18.0942 13.1939C18.3854 13.4885 18.8603 13.4913 19.1549 13.2001L18.1004 12.1333ZM21.4729 13.2001C21.7675 13.4913 22.2424 13.4885 22.5335 13.1939C22.8247 12.8993 22.822 12.4244 22.5274 12.1332L21.4729 13.2001ZM5.31794 16.6061C5.1004 16.2536 4.6383 16.1442 4.28581 16.3618C3.93331 16.5793 3.82391 17.0414 4.04144 17.3939L5.31794 16.6061ZM11.8827 21.75C16.9451 21.75 21.0639 17.6915 21.0639 12.6667H19.5639C19.5639 16.8466 16.1332 20.25 11.8827 20.25V21.75ZM21.0639 12.6667V11H19.5639V12.6667H21.0639ZM19.7867 10.4666L18.1004 12.1333L19.1549 13.2001L20.8411 11.5334L19.7867 10.4666ZM19.7867 11.5334L21.4729 13.2001L22.5274 12.1332L20.8411 10.4666L19.7867 11.5334ZM4.04144 17.3939C5.65405 20.007 8.56403 21.75 11.8827 21.75V20.25C9.10023 20.25 6.66584 18.7903 5.31794 16.6061L4.04144 17.3939Z" fill="#222222"></path> </g></svg>
                                             </span>
                                             </Tooltip>
                                    <Tooltip label='Copy Link'>
                                           
                                         <span
                                           className="sign-btn"
                                           onClick={() => handleCopyLink(signer)}
                                         >
                                           <svg
                                             width="20px"
                                             height="20px"
                                             viewBox="0 0 24 24"
                                             fill="none"
                                             xmlns="http://www.w3.org/2000/svg"
                                           >
                                             <g
                                               id="SVGRepo_bgCarrier"
                                               stroke-width="0"
                                             ></g>
                                             <g
                                               id="SVGRepo_tracerCarrier"
                                               stroke-linecap="round"
                                               stroke-linejoin="round"
                                             ></g>
                                             <g id="SVGRepo_iconCarrier">
                                               {" "}
                                               <path
                                                 d="M3 16V4C3 2.89543 3.89543 2 5 2H15M9 22H18C19.1046 22 20 21.1046 20 20V8C20 6.89543 19.1046 6 18 6H9C7.89543 6 7 6.89543 7 8V20C7 21.1046 7.89543 22 9 22Z"
                                                 stroke="#314064"
                                                 stroke-width="2"
                                                 stroke-linecap="round"
                                                 stroke-linejoin="round"
                                               ></path>{" "}
                                             </g>
                                           </svg>
                                             </span>
                                             </Tooltip>
                                    <Tooltip label='Sign'>
                                             
       
                                         <span
                                           className="sign-btn"
                                           onClick={() => handleSignerClick(signer)}
                                         >
                                           <svg
                                             fill="#314064"
                                             width="20px"
                                             height="20px"
                                             viewBox="0 0 56 56"
                                             xmlns="http://www.w3.org/2000/svg"
                                           >
                                             <g
                                               id="SVGRepo_bgCarrier"
                                               stroke-width="0"
                                             ></g>
                                             <g
                                               id="SVGRepo_tracerCarrier"
                                               stroke-linecap="round"
                                               stroke-linejoin="round"
                                             ></g>
                                             <g id="SVGRepo_iconCarrier">
                                               <path d="M 1.1883 43.4869 L 13.6935 43.4869 C 13.4483 44.4300 13.3162 45.3542 13.3162 46.2030 C 13.3162 49.2397 15.0138 51.4088 18.5786 51.4088 C 22.9168 51.4088 26.4250 48.3532 28.6884 43.4869 L 54.8118 43.4869 C 55.4719 43.4869 56 42.9777 56 42.3175 C 56 41.6574 55.4719 41.1670 54.8118 41.1670 L 29.6315 41.1670 C 30.6877 38.0737 31.3290 34.4523 31.4611 30.5290 C 32.6494 30.2650 33.8941 30.1329 35.1769 30.1329 C 35.8371 30.1329 36.2141 30.4159 36.2141 30.9063 C 36.2141 32.5472 35.3276 33.8298 35.3276 35.4708 C 35.3276 36.9043 36.3841 37.7719 37.7608 37.7719 C 41.5896 37.7719 46.2108 31.2269 47.7385 31.2269 C 49.1342 31.2269 47.3990 37.1117 52.1522 37.1117 C 52.9256 37.1117 53.9253 36.9043 54.6986 36.4139 C 55.1513 36.0932 55.4719 35.6405 55.4719 35.0558 C 55.4719 34.3391 55.0192 33.7544 54.2648 33.7544 C 53.6046 33.7544 53.0577 34.3013 52.4164 34.3013 C 50.3792 34.3013 52.3218 28.0393 48.5687 28.0393 C 45.2868 28.0393 40.1561 34.4145 38.8548 34.4145 C 38.6852 34.4145 38.5531 34.3202 38.5531 34.0939 C 38.5531 33.4149 39.4017 31.8871 39.4017 30.3593 C 39.4017 28.4732 37.8361 27.2660 35.3844 27.2660 C 34.0451 27.2660 32.7248 27.3980 31.4611 27.6432 C 31.0461 17.7032 26.3307 9.8756 19.1256 9.8756 C 14.2782 9.8756 10.5436 14.0063 10.5436 19.2687 C 10.5436 25.4176 14.5423 30.6799 19.5217 34.1693 C 17.3149 36.3384 15.5985 38.8093 14.5423 41.1670 L 1.1883 41.1670 C .5281 41.1670 0 41.6574 0 42.3175 C 0 42.9777 .5281 43.4869 1.1883 43.4869 Z M 13.4106 19.2687 C 13.4106 15.5907 15.9003 12.7426 19.1256 12.7426 C 24.7841 12.7426 28.4432 19.7780 28.6130 28.4166 C 26.0101 29.3219 23.6335 30.6988 21.5776 32.3397 C 17.6544 29.6237 13.4106 25.1347 13.4106 19.2687 Z M .6413 37.1495 C 1.1317 37.6399 1.8673 37.6210 2.3765 37.1495 L 4.7342 34.7918 L 7.0919 37.1495 C 7.5823 37.6399 8.3368 37.6399 8.8272 37.1495 C 9.3176 36.6591 9.3176 35.9046 8.8272 35.4142 L 6.4695 33.0754 L 8.8272 30.7177 C 9.3176 30.2273 9.3176 29.4917 8.8272 29.0012 C 8.3368 28.4920 7.5823 28.5109 7.0919 29.0012 L 4.7342 31.3401 L 2.3765 29.0012 C 1.8673 28.4920 1.1317 28.4920 .6413 29.0012 C .1509 29.4917 .1509 30.2461 .6413 30.7177 L 2.9990 33.0754 L .6413 35.4142 C .1509 35.9235 .1509 36.6591 .6413 37.1495 Z M 23.6335 36.5459 C 23.8787 36.6591 24.1051 36.7156 24.3314 36.7156 C 25.1047 36.7156 25.6517 36.1121 25.6517 35.4708 C 25.6517 34.9992 25.4254 34.5466 24.8784 34.2825 C 24.6143 34.1505 24.3503 34.0184 24.0674 33.8675 C 25.4254 32.9056 26.9343 32.0568 28.5564 31.4155 C 28.3300 35.0558 27.6322 38.4132 26.5571 41.1670 L 17.5790 41.1670 C 18.5597 39.3185 20.0309 37.3758 21.8982 35.6594 C 22.4641 35.9800 23.0488 36.2630 23.6335 36.5459 Z M 16.2586 45.6560 C 16.2586 44.9959 16.3718 44.2603 16.6170 43.4869 L 25.4820 43.4869 C 23.7844 46.6180 21.5022 48.5418 18.8993 48.5418 C 17.0886 48.5418 16.2586 47.3536 16.2586 45.6560 Z"></path>
                                             </g>
                                           </svg>
                                         </span>
                                             </Tooltip>
                                       </>
                                     )}
                                   </div>
                                 </div>
                               ))}
                           </div>
       
                           <p className="note-wrapper">
                             Note: After copying the link and completing the signing
                             process, please download the signed document and upload it
                             in Power of Attorney.
                           </p>
              </Modal>
      
       <Modal
              opened={isWesignModalOpen}
                     onClose={() => { setIsWesignModalOpen(false);setShowContinueBtn(false) }}

             withCloseButton={false}
                    fullScreen={true}
                  padding={0}
            >
               <div style={{ height: "60px", background: "#fff", display: "flex", justifyContent: "flex-end" ,paddingRight:"20px",alignItems:"center"}}>
                               
                               <Close width={'40px'} height={'40px'} onClick={() => {
                                 setShowContinueBtn(false)
                                 setIsWesignModalOpen(false)
                                }} />
                     
                             </div>
                             {
                               showContinueBtn &&  <div className="d-flex justify-content-end signature-modal-btn" >
                               
                               <button
              onClick={() => {
                handleClose()
                setShowContinueBtn(false)
                                 }}
                                 className="signature-btn"
                                
                               >
                                 Please press to continue
                               </button>
                             </div>
                             }
              {wesignUrl ? (
                <iframe
                  src={wesignUrl}
                  title="Wesign"
                  width="100%"
                  height="90%"
                  onLoad={handleLoad}
                  style={{ border: "none" }}
                ></iframe>
              ) : (
                <p>Loading...</p>
              )}
           
            </Modal>
      <div className="dashboard-container">
        <div className="welcome-wrapper">
          <Map className="welcome-map" />
          <div className="greet-wrapper">
            <h4 className="mid-header" style={{ color: "#FAFDFF" }}>
              {/* Welcome back, John */}
              Welcome{" "}
              {/* {data[0]?.first_name ? `back, ${data[0]?.first_name}` : ""} */}
            </h4>
            <span className="sub-header" style={{ color: "#FAFDFF" }}>
              Here’s an overview of your claims
            </span>
          </div>
          <div className="action-wrapper">
            <span
              onClick={() => navigate("/contact-us")}
              className="contact-support sub-header"
              style={{ zIndex: 10 }}
            >
              <HeadephoneIcon /> Contact our support team
            </span>
            <span
              onClick={() => navigate("/account-settings")}
              className="setting-icon"
            >
              <SettingIcon />
            </span>
          </div>
        </div>

        <div className="mobile-wrapper my-claim-header-wrapper">
          <h4 className="dashboard-header">My claims</h4>
          <CustomButton
            onClick={() => navigate("/start-your-claim")}
            btnText={"Start New Claim"}
          />
        </div>
        <div className="my-claim-wrapper desktop-wrapper">
          <div className=" my-claim-header-wrapper">
            <h4 className="dashboard-header">My claims</h4>
            <CustomButton
              onClick={() => navigate("/start-your-claim")}
              btnText={"Start New Claim"}
            />
          </div>

          <div className="table-wrapper" style={{overflowX:"scroll"}}>
           
             
                <div className="table-row table-head" >
                  <span className='table-td table-contact'>Claim ID</span>
                  {/* <span>Edit</span> */}
                  <span className='table-td table-date'>Submitted date</span>
                  <span className='table-td table-name'>Name</span>
                  <span className='table-td table-claim'>Claim type</span>
                  <span className='table-td table-status'>Status</span>
                  <span className='table-td table-message'>Messages</span>
                  <span className='table-td table-document' >Power of Attorney</span>
                  <span className='table-td table-document'>Airline POA</span>
                  <span className='table-td table-document'>Upload Claim Docs</span>
                  <span className='table-td table-buttons' >Access Claim</span>
                </div>
             
              {/* <Table.Tbody>{rows}</Table.Tbody> */}
             
                {data?.length === 0 ? (
                  <div style={{display:"flex",justifyContent:"center"}}>
                    <span  className="text-center py-4">
                      No claims filed yet
                    </span>
                  </div>
                ) : (
                  rows
                )}
             
           
          </div>

           
        </div>

        {
          groupClaimData?.length > 0 &&  <div className="my-claim-wrapper desktop-wrapper">
          
           <div className=" my-claim-header-wrapper">
            <h4 className="dashboard-header">My Group claims</h4>
            <CustomButton
              onClick={() => navigate("/start-group-claim")}
              btnText={"Start Group Claim"}
            />
          </div>
 
         <div className="table-wrapper" style={{overflowX:"scroll"}}>
           
            
             
                <div className="table-row table-head" >
                  <span className='table-td table-contact'>Claim ID</span>
                  {/* <span>Edit</span> */}
                  <span className='table-td table-date'>Submitted date</span>
                  <span className='table-td tabel-group-name'>Group Name</span>
                  <span className='table-td table-claim'>Claim type</span>
                  <span className='table-td table-status'>Status</span>
                  <span className='table-td table-message'>Messages</span>
                  <span className='table-td table-document' >Power of Attorney</span>
                  <span className='table-td table-document'>Airline POA</span>
                  <span className='table-td table-document'>Upload Claim Docs</span>
                  <span className='table-td table-buttons'>Access Claim</span>
                </div>
             
              {/* <Table.Tbody>{rows}</Table.Tbody> */}
             
                {groupClaimData?.length === 0 ? (
                  <div style={{display:"flex",justifyContent:"center"}}>
                    <span  className="text-center py-4">
                      No group claims filed yet
                    </span>
                  </div>
                ) : (
                  groupRows
                )}
             
           
          </div>

          </div>
        }
       

        <div
          className="pagination-container"
          style={{
            marginTop: "20px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            gap: "10px",
          }}
        >
          <button
            onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
            disabled={currentPage === 1}
            style={{
              display: "flex",
              alignItems: "center",
              gap: "6px",
              padding: "8px",
              backgroundColor: "#314064",
              color: "#fff",
              border: "none",
              borderRadius: "20px",
              cursor: currentPage === 1 ? "not-allowed" : "pointer",
              opacity: currentPage === 1 ? 0.6 : 1,
            }}
          >
            <IconChevronLeft size={20} />
          </button>

          <span style={{ fontWeight: "500" }}>
            Page {currentPage} of {totalPages}
          </span>

          <button
            onClick={() =>
              setCurrentPage((prev) => Math.min(prev + 1, totalPages))
            }
            disabled={currentPage === totalPages}
            style={{
              display: "flex",
              alignItems: "center",
              gap: "6px",
              padding: "8px",
              backgroundColor: "#314064",
              color: "#fff",
              border: "none",
              borderRadius: "20px",
              cursor: currentPage === totalPages ? "not-allowed" : "pointer",
              opacity: currentPage === totalPages ? 0.6 : 1,
            }}
          >
            <IconChevronRight size={20} />
          </button>
        </div>

        <div className="mobile-row-wrapper mobile-wrapper">
          {data.length === 0 ? (
            <div style={{ textAlign: "center", marginTop: "30px" }}>
              No claims filed yet
            </div>
          ) : (
            mobileRows
          )}
        </div>


        {
          groupClaimData?.length > 0 && <div className="mobile-row-wrapper mobile-wrapper">
          
            <div className=" my-claim-header-wrapper" style={{justifyContent:'center',margin:'0px 0px !important'}}>
            <h4 className="dashboard-header" >My Group claims</h4>
           
          </div>
          {groupClaimData.length === 0 ? (
            <div style={{ textAlign: "center", marginTop: "30px" }}>
              No group claims filed yet
            </div>
          ) : (
            mobileGroupRows
          )}
        </div>
        }
        
      </div>

       <ViewFileModal
              isOpen={imageModalOpen}
              closeModal={closeImageModal}
              modalTitle={imageModalTitle}
              modalFileUrl={imageModalFileUrl}
      />
      
       <Modal
                  opened={documentNoteOpened}
                  onClose={() =>handleCloseDocumentNote()}
        title="Add Document Note"
        closeOnClickOutside={false}
              radius={'lg'}
                  centered
                >
                  <textarea
                    placeholder="Write your note..."
                    value={documentNote}
                    onChange={(e) => setDocumentNote(e.target.value)}
      
                   className="document-add-note"
                  />
      
                  <div  className="document-note-btn-wrapper">
                    <CustomButton btnText={'Close'} type="secondary" color="red" onClick={() => handleCloseDocumentNote()}/>
                     
                    <CustomButton onClick={() => handleUpdateDocumentNote()}  btnText={'Add Note'}  disabled={documentNote?.trim() === ""}/>
      
                  </div>
                </Modal>
      <Footer />
    </div>
  );
};

export default DashboardPage;
